export default {
    "generalErrorMessage": {
        "fieldIsRequired": "Feld ist erforderlich",
        "field_required": "Dieses Feld ist erforderlich",
        "something_went_wrong": "Etwas ist schief gelaufen"
    },
    "authErrorMessage": {
        "emailError": "Das E-Mail-Feld muss eine gültige E-Mail-Adresse sein",
        "passwordValid": "Das Passwortfeld muss mindestens 8 Zeichen lang sein",
        "validPassRegex": "Passwörter müssen mindestens 8 Zeichen lang sein und mindestens 1 Buchstaben, 1 Großbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten",
        "confirmPasswordValid": "Die Bestätigung des Passworts stimmt nicht überein",
        "validCharactersfirst": "Das Feld Vorname darf nur alphabetische Zeichen und Leerzeichen enthalten",
        "validCharacterslast": "Das Feld Nachname darf nur alphabetische Zeichen und Leerzeichen enthalten",
        "minMust": "muss mindestens 3 Zeichen lang sein",
        "must_be_a_valid_email": "Muss eine gültige E-Mail-Adresse sein",
        "currentPassword": "aktuelle Passwörter müssen mindestens 8 Zeichen lang sein und mindestens 1 Alphabet, 1 Großbuchstaben, 1 Ziffer und 1 Sonderzeichen enthalten",
        "newPassword": "neue Passwörter müssen mindestens 8 Zeichen lang sein und mindestens 1 Alphabet, 1 Großbuchstaben, 1 Ziffer und 1 Sonderzeichen enthalten",
        "currentPasswordValid": "Das aktuelle Passwortfeld muss mindestens 8 Zeichen lang sein",
        "newPasswordValid": "Das neue Passwortfeld muss mindestens 8 Zeichen lang sein",
        "please_wait_before_resending_email": "Bitte überprüfen Sie Ihre E-Mail. Wenn Sie diese nicht erhalten haben, können Sie die Bestätigungs-E-Mail nach 1 Minute erneut senden."
    },
    "companyErrorMessage": {
        "phoneNumberValid": "Das Feld Telefonnummer muss mindestens 10 Zeichen lang sein",
        "Something_went_wrong_Please_contact_to_admin": "Etwas ist schief gelaufen. Bitte wenden Sie sich an den Administrator"
    },
    "errorPage": {
        "project_name": "Projektname",
        "project_key": "Projekt-Schlüssel",
        "project_category": "Projektkategorie",
        "team_name": "Teamname",
        "The": "Das",
        "field_must_be_a_valid": "Feld muss gültig sein",
        "email": "E-Mail",
        "password": "Passwort",
        "first_name": "Vorname",
        "last_name": "Nachname",
        "company_name": "Firmenname",
        "file_extension": "Dateierweiterung",
        "milestone_status": "Meilensteinstatus",
        "name": "Name",
        "phone_number": "Telefonnummer",
        "field_must_be_at_least": "Feld muss mindestens",
        "number": "Nummer",
        "characters": "Zeichen",
        "digits": "Ziffern",
        "priority_name": "Prioritätsname",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "phoneNumber": "Telefonnummer",
        "amount": "Betrag",
        "phone": "Telefon",
        "country": "Land",
        "state": "Bundesland",
        "city": "Stadt",
        "templatename": "Vorlagenname",
        "description": "Beschreibung",
        "Template_name_is_required": "Vorlagenname ist erforderlich",
        "This_template_name_is_required.": "Vorlagenname ist erforderlich.",
        "status": "Status",
        "zipcode": "Postleitzahl",
        "address2": "Adresse 2",
        "address1": "Adresse 1",
        "The_confirm_password_field_is_required": "Das Bestätigungspasswortfeld ist erforderlich",
        "The_confirm_password_confirmation_does_not_match": "Die Bestätigung des Passworts stimmt nicht überein",
        "terms_and_condition": "Allgemeine Geschäftsbedingungen",
        "category_name": "Kategoriename",
        "channel_name": "Kanalname",
        "amount_per_hours": "Betrag pro Stunde",
        "refundamount": "Erstattungsbetrag",
        "please_select_template": "Bitte wählen Sie eine Vorlage aus",
        "template_name_already_exists": "Vorlagenname existiert bereits",
        "select_a_date": "Wählen Sie ein Datum",
        "must_be_less_than": "muss weniger als",
        "project_duedate": "Fälligkeitsdatum des Projekts",
        "project_lead_assignee": "Zuweisung des Projektleiters",
        "current_password": "Aktuelles Passwort",
        "new_password": "Neues Passwort",
        "confirm_password": "Passwort bestätigen",
        "This_template_name_is_already_exists": "Dieser Vorlagenname existiert bereits.",
        "card_name": "Kartenname",
        "topic": "Thema",
        "target_audience": "Zielgruppe",
        "keywords": "Schlüsselwörter",
        "content_purpose": "Inhaltszweck",
        "product/service": "Produkt/Dienstleistung",
        "campaign_goals": "Kampagnenziele",
        "value_proposition": "Wertversprechen",
        "objectives": "Ziele",
        "key_message": "Kernbotschaft",
        "problem": "Problem",
        "context": "Kontext",
        "constraints": "Einschränkungen",
        "main_keyword": "Haupt-Schlüsselwort",
        "secondary_keywords": "Sekundäre Schlüsselwörter",
        "content_goal": "Inhaltsziel",
        "keyword_list": "Schlüsselwort-Liste",
        "questions": "Fragen",
        "product_description": "Produktbeschreibung",
        "feedback_data": "Feedback-Daten",
        "survey_questions": "Umfrage-Fragen",
        "project": "Projekt",
        "progress_made": "Erreichte Fortschritte",
        "next_steps": "Nächste Schritte",
        "key_features": "Hauptmerkmale",
        "client_type": "Kundentyp",
        "challenges": "Herausforderungen",
        "results": "Ergebnisse",
        "event_type": "Veranstaltungstyp",
        "cta": "Handlungsaufforderung",
        "campaign_objectives": "Kampagnenziele",
        "survey_objectives": "Umfrageziele",
        "column_one_name": "Name der ersten Spalte",
        "column_two_name": "Name der zweiten Spalte",
        "column_one_data": "Daten der ersten Spalte",
        "column_two_data": "Daten der zweiten Spalte",
        "customer_name": "Kundenname",
        "email_purpose": "E-Mail-Zweck",
        "talking_points": "Gesprächspunkte",
        "product_name": "Produktname",
        "about_the_product": "Über das Produkt",
        "core_problem_it_solves": "Kernproblem, das es löst",
        "what_makes_it_different": "Was es anders macht",
        "the_product_is": "Das Produkt ist",
        "core_differentiators": "Kern-Differenzierungsmerkmale",
        "product/service_benefits": "Produkt-/Dienstleistungsvorteile",
        "call_notes": "Gesprächsnotizen",
        "call_transcript": "Gesprächstranskript",
        "target_company": "Zielunternehmen",
        "use_case": "Anwendungsfall",
        "customer_challenges": "Kundenherausforderungen",
        "territories": "Gebiete",
        "target_industries": "Zielbranchen",
        "sales_goals": "Verkaufsziele",
        "sales_strategies": "Verkaufsstrategien",
        "transcript": "Transkript",
        "pain_points": "Schmerzpunkte",
        "company_type": "Unternehmenstyp",
        "sales_cycle_stages": "Verkaufszyklus-Phasen",
        "sales_methodologies": "Verkaufsmethodiken",
        "key_skills": "Kernkompetenzen",
        "training_formats": "Schulungsformate",
        "participants": "Teilnehmer",
        "target_industry": "Zielbranche",
        "value_statement": "Wertaussage",
        "meeting_type": "Besprechungstyp",
        "your_talking_points": "Ihre Gesprächspunkte",
        "goal": "Ziel",
        "reasons_for_canceling": "Stornierungsgründe",
        "incentive": "Anreiz",
        "unique_selling_points": "Alleinstellungsmerkmale",
        "desired_format": "Gewünschtes Format",
        "topics": "Themen",
        "content": "Inhalt",
        "stakeholders": "Interessensgruppen",
        "sales_notes": "Verkaufsnotizen",
        "customer_goals": "Kundenziele",
        "teams_impacted": "Betroffene Teams",
        "requirements": "Anforderungen",
        "goals_met": "Erreichte Ziele",
        "project_stakeholders": "Projekt-Interessensgruppen",
        "opportunities": "Chancen",
        "risks": "Risiken",
        "customer_message": "Kundennachricht",
        "date_range": "Datumsbereich",
        "project_notes": "Projektnotizen",
        "project_description": "Projektbeschreibung",
        "name_of_project": "Projektname",
        "date_ranges": "Datumsbereiche",
        "requestor": "Antragsteller",
        "requests": "Anfragen",
        "reason_for_the_change": "Grund für die Änderung",
        "expected_impact_of_the_change": "Erwartete Auswirkungen der Änderung",
        "project_goals": "Projektziele",
        "participant_names": "Teilnehmernamen",
        "meeting_time": "Besprechungszeit",
        "timeline": "Zeitplan",
        "deliverables": "Liefergegenstände",
        "project_goal": "Projektziel",
        "project_scope": "Projektumfang",
        "main_task": "Hauptaufgabe",
        "new_format": "Neues Format",
        "original_text": "Originaltext",
        "stakeholder_titles": "Titel der Interessensgruppen",
        "article_title": "Artikeltitel",
        "focus_keywords": "Fokus-Schlüsselwörter",
        "title_of_the_blog_text": "Titel des Blog-Textes",
        "blog_topic": "Blog-Thema",
        "section_title": "Abschnittstitel",
        "section_content": "Abschnittsinhalt",
        "section": "Abschnitt",
        "title": "Titel",
        "title(faq_question)": "Titel(faq Frage)",
        "issue_description": "Problembeschreibung",
        "code_section": "Code-Abschnitt",
        "concept": "Konzept",
        "version": "Version",
        "changes": "Änderungen",
        "job_title": "Stellentitel",
        "your_name": "Ihr Name",
        "your_skills": "Ihre Fähigkeiten",
        "math_question": "Mathematik-Frage",
        "question": "Frage",
        "thesis_topic": "Thema der Abschlussarbeit",
        "text_to_proofread": "Zu korrigierender Text",
        "text_to_rephrase": "Umzuformulierender Text",
        "text_to_improve": "Zu verbessernder Text",
        "job_description": "Stellenbeschreibung",
        "your_title": "Ihr Titel",
        "your_summary": "Ihre Zusammenfassung",
        "pain": "Schmerz",
        "agitation": "Aufregung",
        "solution": "Lösung",
        "post_content": "Beitragsinhalt",
        "product_or_service": "Produkt oder Dienstleistung",
        "unique_selling_proposition": "Alleinstellungsmerkmal",
        "audiences_objectives": "Ziele der Zielgruppe",
        "email_to_reply_to": "Antwort E Mail",
        "sales_teams_roles": "Rollen des Verkaufsteams"
    },
    "Auth": {
        "email": "E-Mail",
        "password": "Passwort",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "phoneNumber": "Telefonnummer",
        "login_descriptioon": "Sehen Sie, was in Ihrem Unternehmen passiert",
        "login_statement": "Melden Sie sich bei Ihrem Konto an",
        "email_id": "E-Mail-ID",
        "Password": "Passwort",
        "Conform_pass": "Passwort bestätigen",
        "RememberMeL": "Angemeldet bleiben",
        "Remember_password": "Passwort merken",
        "Forgot_Password": "Passwort vergessen",
        "loading": "Wird geladen",
        "loging": "Anmelden",
        "Register": "Registrieren",
        "NotR": "Noch nicht registriert",
        "createAcc": "Ein Konto erstellen",
        "alredyacc": "Haben Sie bereits ein Konto?",
        "ResendEmail": "E-Mail erneut senden",
        "pleasecheck": "Bitte überprüfen Sie Ihre E-Mail. Wenn Sie sie nicht erhalten haben oder sie verloren haben, klicken Sie unten, um die E-Mail erneut zu senden.",
        "backlogin": "Zurück zur Anmeldung",
        "Welcome_Msg": "Willkommen bei BRAND_NAME",
        "Welcome_Description": "Erhalten Sie Zugang zu exklusiven Funktionen, indem Sie ein Konto erstellen",
        "agree": "Ich stimme den",
        "tearm": "Nutzungsbedingungen",
        "and": "und",
        "Privacy_Policy": "Datenschutzrichtlinie",
        "forgatepasswordmsg": "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein, und wir senden Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts.",
        "ltitle": "Arbeiten Sie an großen Ideen, ohne den ganzen Aufwand.",
        "time_format": "Zeitformat",
        "timezone": "Zeitzone",
        "selectLanguage": "Sprache auswählen",
        "check_credentials": "Bitte überprüfen Sie Ihre Anmeldedaten.",
        "check_smtp_credentials": "Bitte überprüfen Sie Ihre SMTP-Anmeldedaten.",
        "smtp_successfully_verified": "Ihr SMTP wurde erfolgreich verifiziert.",
        "verification_code_invalid": "Ihr Bestätigungscode ist ungültig.",
        "verification_code_invalid_check_code": "Ihr Bestätigungscode ist ungültig. Bitte überprüfen Sie Ihren Code.",
        "verification_mail_sent": "Die Bestätigungs-E-Mail wurde erfolgreich gesendet. Bitte überprüfen Sie Ihren Posteingang.",
        "no_account_found_for_email": "Kein Konto für die angegebene E-Mail-Adresse gefunden.",
        "verify_email_and_try_again": "Überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
        "confirm_password": "Passwort bestätigen",
        "enter_new_password": "Bitte geben Sie Ihr neues Passwort ein",
        "link_expired_resend_email": "Ihr Link ist abgelaufen.",
        "reset_password": "Passwort zurücksetzen",
        "resend_verification_email": "Klicken Sie auf die Schaltfläche, um die Bestätigungs-E-Mail erneut zu senden",
        "link_expired": "Dieser Link ist abgelaufen",
        "too_many_request": "Sie haben zu viele Anfragen in kurzer Zeit gesendet. Bitte warten Sie und versuchen Sie es später erneut.",
        "previous_wasnot_valid": " Ihr vorheriges Passwort war ungültig. Bitte überprüfen Sie es und versuchen Sie es erneut.",
        "password_wasnot_valid": "Ihr neues Passwort war ungültig. Bitte versuchen Sie es erneut.",
        "set_new_password": "Neues Passwort setzen",
        "verification_link_expired": "Dieser Bestätigungslink ist abgelaufen.",
        "verification_link_expired_message": "Bitte überprüfen Sie Ihren Posteingang auf die neueste Bestätigungs-E-Mail. Wenn Sie sie nicht erhalten haben, versuchen Sie, sich erneut anzumelden, um eine neue anzufordern.",
        "oAuthGoogleBtnText": "Mit Google fortfahren"
    },
    "Home": {
        "unlock": "Entsperren",
        "lock": "Sperren",
        "dashboardLockSuccess": "Dashboard erfolgreich gesperrt",
        "dashboardUnlockSuccess": "Dashboard erfolgreich entsperrt",
        "Home": "Startseite",
        "My_Work": "Meine Arbeit",
        "Done": "Erledigt",
        "To_Do": "Zu tun",
        "no_task_found": "Keine Aufgaben gefunden",
        "Confirm": "Bestätigen",
        "tourclose": "Sind Sie sicher, dass Sie diese Tour schließen möchten? Wenn Sie bestätigen, können Sie auf diesen Tour-Guide nicht mehr zugreifen.",
        "Queue_List": "Warteschlangenliste",
        "AddtoQueue": "Zur Warteschlange hinzufügen",
        "noquelist": "Keine Warteschlangenliste gefunden",
        "Due_Date": "Fälligkeitsdatum",
        "createQueueTitle": "Warteschlange erstellen",
        "Today": "Heute",
        "Calendar": "Kalender",
        "Hide": "Verbergen",
        "Overdue": "Überfällig",
        "Next": "Nächster",
        "Unscheduled": "Nicht geplant",
        "task_assign_to_you": "Aufgabe Ihnen zugewiesen",
        "Notification_Request": "Benachrichtigungsanfrage",
        "no": "Nein",
        "yes": "Ja",
        "add_task_type": "Aufgabentyp hinzufügen",
        "are_you_sure": "Möchten Sie Benachrichtigungen im Browser aktivieren?"
    },
    "Header": {
        "Project_Forecasting": "პროექტის პროგნოზირება (მალე დაემატება)",
        "Resource_Planning": "რესურსების დაგეგმვა (მალე დაემატება)",
        "Projects": "Projekte",
        "Time_Sheet": "Zeiterfassung",
        "User_Timesheet": "Benutzer-Zeiterfassung",
        "project_Timesheet": "Projekt-Zeiterfassung",
        "Workload_Timesheet": "Arbeitsbelastungs-Zeiterfassung",
        "Tracker_Timesheet": "Tracker-Zeiterfassung",
        "Reports": "Berichte",
        "Milestone_Report": "Meilensteinbericht",
        "Time_Forcasting": "Zeitvorhersage",
        "Chat": "Chat",
        "Notification": "Benachrichtigung",
        "mention": "Erwähnung",
        "Tours": "Touren",
        "Logout": "Abmelden",
        "Mark_all_as_read": "Alle als gelesen markieren",
        "Mark_all_as_complete": "Alle als abgeschlossen markieren",
        "designation": "Bezeichnung",
        "upgrade_now": "Jetzt upgraden",
        "load_more": "Mehr laden",
        "take_tour": "Tour machen",
        "task_details": "Aufgabendetails",
        "Comments": "Kommentare",
        "activity_log": "Aktivitätsprotokoll",
        "time_log": "Zeiterfassungsprotokoll",
        "mentions": "Erwähnungen",
        "Notifications": "Benachrichtigungen",
        "no_data_found": "Keine Daten gefunden",
        "search_results": "Suchergebnisse",
        "my_profile": "Mein Profil",
        "billing_history": "Abrechnungshistorie",
        "Assignee": "Zugewiesene Person",
        "Due Date": "Fälligkeitsdatum",
        "Priority": "Priorität",
        "Key": "Schlüssel",
        "Created Date": "Erstellungsdatum",
        "Created By": "Erstellt von",
        "advance_search": "Erweiterte Suche",
        "for_advance_search": "Für erweiterte Suche",
        "get_more": "Mehr bekommen?",
        "to_unlock_activity_view": "Um die Aktivitätsansicht freizuschalten",
        "AssigneeUserId": "Zugewiesene Person",
        "DueDate": "Fälligkeitsdatum",
        "TaskKey": "Schlüssel",
        "Task_Priority": "Priorität",
        "commentCounts": "Chat",
        "created_by": "Erstellt von",
        "created_date": "Erstellungsdatum",
        "create_project": "Projekt erstellen",
        "Company": "Firma"
    },
    "ProjectDetails": {
        "select_project_category": "Projektkategorie auswählen",
        "select_currency": "Währung auswählen",
        "description": "Beschreibung",
        "details": "Details",
        "status": "Status",
        "assignee": "Zugewiesene Person",
        "key": "Schlüssel",
        "category": "Kategorie",
        "source": "Quelle",
        "type": "Typ",
        "billing_period": "Abrechnungszeitraum",
        "currency": "Währung",
        "amount": "Betrag",
        "start_date": "Startdatum",
        "end_date": "Enddatum",
        "no_start_date": "Kein Startdatum",
        "no_end_date": "Kein Enddatum",
        "no_due_date": "Kein Fälligkeitsdatum",
        "msg": "Das Startdatum kann nicht geändert werden, da es bereits",
        "msgbr": "innerhalb eines Meilensteinbereichs liegt.",
        "startdatemsg0": "Das Startdatum kann nicht geändert werden, da es bereits",
        "startdatemsg1": "innerhalb eines Meilensteinbereichs liegt.",
        "ok": "OK",
        "lead": "Lead",
        "browse_by_category": "Nach Kategorie durchsuchen",
        "subtask": "Unteraufgabe",
        "details_project_setup": "Details zur Projekteinrichtung",
        "avatar": "Avatar",
        "shared_with": "Geteilt mit",
        "no_user_selected": "Keine Benutzer ausgewählt",
        "required_view": "Erforderliche Ansichten",
        "set_the_require": "Legen Sie die Ansicht(en) fest, die Sie benötigen. Diese Ansichten werden automatisch angezeigt, wenn Sie zu Projekten, Ordnern und Listen in BRAND_NAME navigieren, anstatt sie manuell zu erstellen. Einmal erstellt, können Ansichten nicht gelöscht werden.",
        "always_required": "Immer erforderlich",
        "make_default": "Als Standard festlegen",
        "reporter": "Reporter",
        "copy_task_link": "Task-Link kopieren",
        "copy_task_key": "Task-Schlüssel kopieren",
        "add_que_list": "Zur Warteschlangenliste hinzufügen",
        "remove_que_list": "Von der Warteschlangenliste entfernen",
        "convert_list": "In Liste umwandeln",
        "convert_subtask": "In Unteraufgabe umwandeln",
        "merge": "Zusammenführen",
        "move": "Bewegen",
        "convert_task": "In Aufgabe umwandeln",
        "no_currency_found": "Keine Währung gefunden",
        "remove_from_queue_list": "Von der Warteschlangenliste entfernen",
        "convert": "Konvertieren",
        "DUPLICATE_AND_OPEN": "Duplizieren und Öffnen",
        "MOVE_AND_OPEN": "Bewegen und Öffnen",
        "CONVERT_AND_OPEN": "Konvertieren und Öffnen",
        "MERGE_AND_OPEN": "Zusammenführen und Öffnen"
    },
    "ProjectSlider": {
        "new_project": "Neues Projekt",
        "no_archived": "Keine archivierten Daten gefunden",
        "you_dont": "Sie haben keine Projekte",
        "archived_list": "Archivierte Liste",
        "projects": "Projekte",
        "project_name": "Projektname",
        "folder_name": "Ordnername",
        "sprint_name": "Sprintname",
        "show_archive": "Archiv anzeigen",
        "hide_archive": "Archiv verbergen",
        "try_using_diff": "Versuchen Sie, andere Schlüsselwörter zu verwenden",
        "no_project_found": "Keine Projekte gefunden",
        "no_result_found": "Keine Ergebnisse gefunden",
        "select_project_status": "Projektstatus auswählen",
        "no_activity_log_found": "Kein Aktivitätsprotokoll gefunden"
    },
    "Projects": {
        "sprint": "Sprint",
        "folder": "Ordner",
        "task_view": "Aufgabenansicht",
        "default_view": "Standardansicht",
        "add_view": "Ansicht hinzufügen",
        "rename": "Umbenennen",
        "pin": "Anheften",
        "edit_code": "Code bearbeiten",
        "copy_link": "Link kopieren",
        "delete": "Löschen",
        "view": "Ansicht",
        "watchers": "Beobachter",
        "files_links": "Dateien & Links",
        "audio_files": "Audiodateien",
        "project_permissions": "Projektberechtigungen",
        "color_avatar": "Farbe & Avatar",
        "duplicate": "Duplizieren",
        "close_project": "Projekt schließen",
        "archive": "Archivieren",
        "search_in": "Durchsuchen in",
        "expanded": "Erweitert",
        "collapsed": "Eingeklappt",
        "me": "Ich",
        "status": "Status",
        "priority": "Priorität",
        "due_date": "Fälligkeitsdatum",
        "group_by": "Gruppieren nach",
        "subtask": "Unteraufgabe",
        "task_name": "Aufgabenname",
        "task_key": "Task-Schlüssel",
        "everyone": "Jeder",
        "private": "Privat",
        "share_with": "Teilen mit",
        "create_new_list": "Neue Sprint erstellen",
        "create_new_folder": "Neuen Ordner erstellen",
        "restore": "Wiederherstellen",
        "unpin": "Von der Ansicht lösen",
        "pinview": "Ansicht anheften",
        "deleteview": "Ansicht löschen",
        "close": "Schließen",
        "cancel": "Abbrechen",
        "tasks": "Aufgaben",
        "save": "Speichern",
        "create_project": "Projekt erstellen",
        "use_template": "Template verwenden",
        "blank_project": "Leeres Projekt",
        "no_category_found": "Keine Kategorie gefunden",
        "template": "Vorlage",
        "save_create": "Speichern & Erstellen",
        "save_tamplete": "Als Vorlage speichern",
        "previous": "Zurück",
        "new_task": "Neue Aufgabe",
        "add_subtask": "Unteraufgabe hinzufügen",
        "list_of_user": "Benutzerliste",
        "list_of_project_status": "Liste der Projektstatus",
        "list_of_task_type": "Liste der Aufgabentypen",
        "list_of_task_status": "Liste der Aufgabenzustände",
        "list_cc": "Liste CC",
        "category_list": "Kategorieliste",
        "created_by": "Erstellt von",
        "tags": "Tags",
        "task_type": "Aufgabentyp",
        "workspace": "Arbeitsbereich",
        "project_color": "Projektfarbe",
        "search": "Suchen",
        "add_task_need": "Fügen Sie den benötigten Aufgabentyp hinzu",
        "what_task_want": "Welchen Aufgabentyp möchten Sie?",
        "no_sub_tasks_found": "Keine Unteraufgaben gefunden",
        "all_project": "Alle Projekte",
        "closed_project": "Geschlossenes Projekt",
        "go_to_project": "Zum Projekt gehen",
        "reopen_project": "Projekt wieder öffnen",
        "required_view": "Erforderliche Ansichten",
        "project_status": "Fügen Sie die Status für das Projekt hinzu",
        "what_project": "Welchen Projektstatus möchten Sie?",
        "active_status": "Aktiver Status",
        "done_status": "Erledigt-Status",
        "add_status": "Status hinzufügen",
        "close_status": "Status schließen",
        "submit": "Absenden",
        "Audio_Files": "Audiodateien",
        "Files_&_Links": "Dateien & Links",
        "no_audio_file": "Keine Audiodateien gefunden",
        "change_color": "Farbe & Avatar ändern",
        "files": "Dateien",
        "links": "Links",
        "about": "Über",
        "result": "Ergebnisse",
        "seconds": "Sekunden",
        "sort_by": "Sortieren nach",
        "relevance": "Relevanz",
        "last_update": "Zuletzt aktualisiert",
        "last_created": "Zuletzt erstellt",
        "issue": "Problem",
        "update": "Aktualisieren",
        "date": "Datum",
        "time": "Zeit",
        "duration": "Dauer",
        "duplicate_task": "Aufgabe duplizieren",
        "projects": "Projekte",
        "browse_projects": "Projekte durchsuchen",
        "location": "Standort",
        "add_new": "Neu hinzufügen",
        "create_compnay": "Firma erstellen",
        "company_name": "Firmenname",
        "archived_project": "Archiviertes Projekt",
        "assignee_teams": "Teams",
        "assignee_user": "Benutzer",
        "all": "Alle",
        "restore_project": "Projekt wiederherstellen",
        "delete_project": "Projekt löschen",
        "items_per_page": "Elemente pro Seite",
        "Assignee": "Zugewiesene Person",
        "Project_Created_Date": "Projekt Erstellungsdatum",
        "Project_Status": "Projektstatus",
        "Project_Type": "Projektart",
        "Comments_Counts": "Anzahl der Kommentare",
        "Created_Date": "Erstellungsdatum",
        "Name": "Name",
        "Running_Time_Tracker": "Laufender Zeit Tracker",
        "Assigned_to": "Zugewiesen an",
        "Project": "Projekt",
        "Currency": "Währung",
        "Milestone_Type": "Meilenstein-Typ",
        "Project_Category": "Projektkategorie",
        "Comment_Type": "Kommentar-Typ",
        "results_in_time": "Ergebnisse in",
        "create_blank_project": "Leeres Projekt erstellen",
        "create_project_using_template": "Projekt mit Vorlage erstellen",
        "choose_apps": "Wählen Sie Apps aus"
    },
    "Watcher": {
        "ignore": "Ignorieren",
        "participating_mentions": "Teilnehmende und {'@'}Erwähnungen",
        "list_of_watcher": "Liste der Beobachter",
        "all_activity": "Alle Aktivitäten",
        "watchers_list": "Beobachterliste",
        "owner": "Besitzer"
    },
    "ViewList": {
        "List": "Liste",
        "Board": "Tafel",
        "Project Details": "Projekt Details",
        "Comments": "Kommentare",
        "Calendar": "Kalender",
        "Activity": "Aktivität",
        "Workload": "Arbeitslast",
        "Gantt": "Gantt",
        "Table": "Tabelle",
        "Timeline": "Zeitleiste",
        "Embed": "Einbetten",
        "Comment": "Kommentar",
        "to_unlock_list_view": "Um die Listenansicht freizuschalten",
        "error_message_for_empty": "Bitte wählen Sie mindestens eine Ansicht aus",
        "set_as_default": "Als Standard festlegen",
        "remove_as_default": "Als Standard entfernen"
    },
    "Apps": {
        "tags": "Tags",
        "Priority": "Priorität",
        "TimeEstimates": "Zeitschätzung",
        "Milestones": "Meilensteine",
        "MultipleAssignees": "Mehrere Zuweisungen",
        "CustomFields": "Benutzerdefinierte Felder",
        "TimeTracking": "Zeiterfassung",
        "AI": "KI"
    },
    "Tags": {
        "no_tags_found": "Keine Tags gefunden",
        "search_or_create_new": "Suchen oder neuen erstellen",
        "change_color": "Farbe ändern",
        "delete_tag": "Tag löschen",
        "delete_tag_desc": "Sind Sie sicher, dass Sie den Tag überall in diesem Space löschen möchten?",
        "note_msg": "Drücken Sie die Eingabetaste, um ein neues Tag zu erstellen",
        "This_tag_has_already_been_added": "Dieses Tag wurde bereits hinzugefügt",
        "Tag_name_required": "Tag-Name erforderlich"
    },
    "Embeded": {
        "Anything": "Alles",
        "Sheets": "Google Sheets",
        "Docs": "Google Docs",
        "Youtube": "Youtube",
        "Figma": "Figma",
        "The_name_is_required": "Der Name ist erforderlich",
        "The_name_should_be_at_least_3_characters_long": "Der Name sollte mindestens 3 Zeichen lang sein",
        "The_url_is_required": "Die URL ist erforderlich",
        "Please_enter_valid_url": "Bitte geben Sie eine gültige URL ein",
        "URL_already_exists": "URL existiert bereits",
        "The_Html_code_is_required": "Der HTML-Code ist erforderlich",
        "name_already_exists": "Dieser Name existiert bereits",
        "to_unlock_embed_view": "Um die Embed-Ansicht freizuschalten"
    },
    "ViewListdescription": {
        "list_view": "Verwenden Sie die Listenansicht, um Ihre Aufgaben auf jede erdenkliche Weise zu organisieren – sortieren, filtern, gruppieren und Spalten anpassen.",
        "kanban_view": "Erstellen Sie Ihre perfekte Tafel und ziehen Sie Aufgaben mühelos zwischen den Spalten hin und her.",
        "projectdetail_view": "Fügen Sie die ersten Anforderungen, Checklisten und Anhänge hinzu, damit Ihr Team die Details versteht.",
        "Comments_view": "Fügen Sie in Echtzeit Kommentare zu allem hinzu, damit Ihr Team benachrichtigt wird und antworten kann.",
        "calender_view": "Die Kalenderansicht ist der Ort für Planung, Terminierung und Ressourcenmanagement.",
        "table_view": "Verwalten, aktualisieren und organisieren Sie Ihre Aufgaben einfach mit der Tabellenansicht.",
        "workload_view": "Sehen Sie die Kapazität Ihres Teams, wer überlastet oder unterlastet ist, und ordnen Sie Aufgaben entsprechend neu zu.",
        "activitylog_view": "Erhalten Sie eine aggregierte Ansicht aller Aktivitäten an einem Ort. Filtern Sie nach Personen und Typ, um detaillierte Aktivitäten anzuzeigen.",
        "add_msg1": "Fügen Sie Apps und Webseiten zusammen mit Ihren Aufgaben in der Embed-Ansicht hinzu",
        "add_msg2": "um Zeit zu sparen und den Kontextwechsel zu verringern.",
        "view_name": "Ansichtsname",
        "embed_URL": "Embed-URL",
        "embed_HTML": "Embed-HTML",
        "private_view": "Private Ansicht"
    },
    "Filters": {
        "filter": "Filter",
        "learnmorefilter": "Erfahren Sie mehr über Filter",
        "pleaseselectvalid": "Bitte wählen Sie alle gültigen Optionen aus",
        "confirm": "Bestätigen",
        "are_you_sure": "Sind Sie sicher, dass Sie löschen möchten?",
        "clearall": "Alles löschen",
        "addfilter": "Filter hinzufügen",
        "where": "Wo",
        "filtering_field": "Filterfeld",
        "no_date_found": "Kein Datum gefunden",
        "save_this_filters": "Diesen Filter speichern",
        "save_filter": "Filter speichern",
        "save": "Speichern",
        "update_filter": "Filter aktualisieren",
        "my_filter": "Mein Filter",
        "no_data_found": "Keine Daten gefunden",
        "show_result": "Ergebnisse anzeigen",
        "save_filters": "Filter speichern",
        "filter_by": "Filtern nach",
        "projects": "Projekte",
        "teams": "Teams",
        "user": "Benutzer",
        "no_comment_found": "Kein Kommentar gefunden",
        "no_project_found": "Kein Projekt gefunden",
        "no_file_found": "Keine Datei gefunden",
        "no_link_found": "Kein Link gefunden",
        "filter_operator": "Filteroperator",
        "options": "Optionen",
        "priorities": "Prioritäten",
        "select_all": "Alle auswählen",
        "milestone_type": "Meilensteintyp",
        "comment_type": "Kommentar-Typ",
        "a_to_z": "A bis Z",
        "no_files_found": "Keine Dateien gefunden",
        "no_links_found": "Keine Links gefunden",
        "no_links_or_files_found": "Keine Links oder Dateien gefunden",
        "z_to_a": "Z bis A",
        "sort_by": "Sortieren nach",
        "A-Z": "A-Z",
        "Ascending": "Aufsteigend",
        "Descending": "Absteigend",
        "No": "Nein",
        "Yes": "Ja",
        "Z-A": "Z-A",
        "Save_this_Filter": "Diesen Filter speichern",
        "Enter_Filter_Name": "Filtername eingeben",
        "Select_Options": "Optionen auswählen",
        "Equal_To": "Gleich",
        "Greater_Than": "Größer als",
        "Is": "Ist",
        "Less_Than": "Weniger als",
        "Clear_All": "Alles löschen",
        "select_assignee": "Zuweisung auswählen",
        "select_project_types": "Projekttypen auswählen",
        "unselect_all": "Alles abwählen",
        "are_you_suredelete": "Sind Sie sicher, dass Sie löschen möchten?",
        "Not_Equals_To": "Ist nicht"
    },
    "conformationmsg": {
        "archive": "Eine Liste kann archiviert werden, um sie aus der Ansicht zu entfernen, aber jederzeit wiederhergestellt zu werden. Alle Aufgaben bleiben erhalten und sind weiterhin durchsuchbar, wenn Sie eine Liste archivieren.",
        "delete": "Die Aufgaben und Vorlagen dieses Projekts werden alle gelöscht. Geben Sie den Projektnamen ein, um zu bestätigen, dass Sie wirklich alle Aufgaben, Vorlagen und dieses Projekt löschen möchten.",
        "archive0mesg": "Geben Sie den Projektnamen ein, um zu bestätigen, dass Sie dieses Projekt wirklich schließen möchten.",
        "sprintclosemsg": "Geben Sie den Sprintnamen ein, um zu bestätigen, dass Sie diesen Sprint wirklich schließen möchten.",
        "type": "Typ",
        "are_you_sure": "Bist du sicher?",
        "no_revert_msg": "Sie können dies nicht rückgängig machen!",
        "yes_delete": "Ja, löschen!",
        "task_will_become_subtasks_of": "Die Aufgabe wird zu Unteraufgaben von",
        "Are_you_sure_you_want_to_delete": "Sind Sie sicher, dass Sie löschen möchten?",
        "subtasks_will_become_subtasks_of": "Unteraufgaben werden zu Unteraufgaben von",
        "unlock_board_view": "Um die Board-Ansicht freizuschalten",
        "unlock_project_detail_view": "Um die Projekt-Detail-Ansicht freizuschalten",
        "unlock_table_view": "Um die Tabellen-Ansicht freizuschalten",
        "unlock_workload_view": "Um die Arbeitslast-Ansicht freizuschalten",
        "to_unlock_tracker_timesheet": "Um das Tracker-Zeiterfassungsblatt freizuschalten",
        "to_unlock_user_timesheet": "Um das Benutzer-Zeiterfassungsblatt freizuschalten",
        "unlock_calendar_view": "Um die Kalenderansicht freizuschalten"
    },
    "Description": {
        "description": "Beschreibung",
        "edit": "Bearbeiten",
        "add_description": "Beschreibung hinzufügen",
        "show_more": "Mehr anzeigen",
        "show_less": "Weniger anzeigen",
        "description_placeholder": "Schreiben Sie etwas oder tippen Sie '/' für Befehle und KI-Aktionen",
        "saved": "Gespeichert"
    },
    "Checklist": {
        "checklist": "Checkliste",
        "add_checklist": "Checkliste hinzufügen",
        "suggest_checklists": "Checklisten vorschlagen",
        "Checklists": "Checklisten",
        "to_unlock_checklist": "Um die Checkliste freizuschalten"
    },
    "Attachments": {
        "attachments": "Anhänge",
        "drag_file": "Hier können Sie auch Dateien per Drag & Drop hinzufügen.",
        "see_all": "Alle anzeigen",
        "drop_file": "Dateien hier ablegen, um sie anzuhängen oder",
        "browse": "Durchsuchen",
        "no_preview_found": "Keine Vorschau gefunden",
        "show_all_pages": "Alle Seiten anzeigen",
        "drop_here": "Hier ablegen"
    },
    "Milestone": {
        "milestone": "Meilenstein",
        "milestone_name": "Meilenstein-Name",
        "status_date": "Status-Datum",
        "total_amount": "Gesamtbetrag",
        "are_you_sure": "Sind Sie sicher, dass Sie den Meilenstein löschen möchten?",
        "add_new": "Neuen hinzufügen",
        "mileston_status": "Meilenstein-Status",
        "project_name": "Projektname",
        "end_date": "Enddatum",
        "start_date": "Startdatum",
        "estimated_release": "Geschätzte Veröffentlichung",
        "release_request_sent": "Freigabeberechtigungsanfrage gesendet",
        "released": "Freigegeben",
        "not_funded": "Nicht finanziert",
        "funded": "Finanziert",
        "project_milestone_Status": "Projekt-Meilenstein-Status",
        "milestone_status_name": "Meilenstein-Status-Name",
        "date_displaye": "Datum in Kalender angezeigt",
        "past": "Vergangenheit",
        "feature": "Zukunft",
        "milestone_weekly_range": "Wöchentlicher Meilensteinbereich",
        "file_extensions": "Dateierweiterungen",
        "avatar": "Avatar",
        "adding_estimated": "Geschätzte Stunden hinzufügen",
        "range": "Bereich",
        "user": "Benutzer",
        "refunded_amount": "Erstatteter Betrag",
        "Max_2_decimal_places_allowed": "Maximal 2 Dezimalstellen erlaubt",
        "The_refunded_amount_field_should_not_be_more_then_amount": "Das Feld für den erstatteten Betrag darf nicht mehr als der Betrag sein.",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "Das Feld für den Betrag sollte nicht kleiner als der erstattete Betrag sein.",
        "The_minute_field_must_be_59_or_less": "Das Minutenfeld muss 59 oder weniger sein",
        "The_hours_field_is_required": "Das Stundenfeld ist erforderlich",
        "Name_already_exists": "Name existiert bereits",
        "The_milestone_status_field_is_required": "Das Feld für den Meilenstein-Status ist erforderlich",
        "The_milestone_status_field_must_be_at_leat_characters": "Das Feld für den Meilenstein-Status muss mindestens 3 Zeichen lang sein",
        "actual_amount": "Tatsächlicher Betrag",
        "partially_refunded": "Teilweise erstattet",
        "refunded_amount_should_not_exceed_amount": "Der erstattete Betrag darf den Betrag nicht überschreiten",
        "total_partially_refunded": "Insgesamt teilweise erstattet",
        "field_should_not_be_smaller_than_refund_amount": "Das Feld sollte nicht kleiner als der Rückerstattungsbetrag sein",
        "white_color_not_allowed": "Weiß ist nicht erlaubt. Bitte wählen Sie eine gültige Farbe aus",
        "billing": "Abrechnung",
        "per_hour": "Pro Stunde",
        "adding_taskPlanning": "Aufgabe Aufgabenplanung hinzufügen"
    },
    "Comment": {
        "created_by": "Erstellt von",
        "created_on": "Erstellt am",
        "task_name": "Aufgabenname"
    },
    "UserTimesheet": {
        "back_projects": "Zurück zu Projekten",
        "user_timesheet": "Benutzer-Zeiterfassungsblatt",
        "back": "Zurück",
        "tracked_time": "Verfolgte Zeit",
        "manual_time": "Manuelle Zeit",
        "users": "Benutzer",
        "logged": "Protokolliert",
        "hours": "Stunden",
        "estimated": "Geschätzt",
        "no_records_found": "Keine Datensätze gefunden",
        "project_timesheet": "Projekt-Zeiterfassungsblatt",
        "tracker_timesheet": "Tracker-Zeiterfassungsblatt",
        "workload_timesheet": "Arbeitslast-Zeiterfassungsblatt",
        "milestone_reports": "Meilensteinberichte",
        "add_time": "Zeit hinzufügen",
        "add_time_log": "Zeitprotokoll hinzufügen",
        "edit_time_log": "Zeitprotokoll bearbeiten",
        "Teams": "Teams",
        "Users": "Benutzer",
        "Projects": "Projekte",
        "task_planning": "„Aufgabenplanung",
        "task_remaining_planning": "Verbleibende Stunden",
        "planned": "Geplant"
    },
    "ProjectWorkplace": {
        "msg1": "Projekte können mit Mitgliedern geteilt werden. Sie können Gäste zu Ordnern, Listen und Aufgaben hinzufügen, nachdem ein Projekt erstellt wurde.",
        "msg2": "Derzeit gibt es keine Pläne, private oder öffentliche Projekte zu erstellen. Wenn Sie ein Projekt initiieren möchten, ist ein Upgrade auf Ihren Plan erforderlich."
    },
    "CustomField": {
        "custom_field": "Benutzerdefiniertes Feld",
        "create_custom_field": "Benutzerdefiniertes Feld erstellen",
        "lable": "Label",
        "action": "Aktion",
        "add_custom_field": "Benutzerdefiniertes Feld hinzufügen",
        "add_new_custom_field": "Neues benutzerdefiniertes Feld hinzufügen",
        "field_name": "Feldname",
        "date_created": "Erstellungsdatum",
        "add_another_item": "Ein weiteres Element hinzufügen",
        "choose_ready_made_list": "Wählen Sie eine vorgefertigte Liste von Optionen (z. B. Tage, Monate usw.)",
        "predefined_options": "Vordefinierte Optionen",
        "selected_by_default": "Standardmäßig ausgewählt",
        "allow_time_with_date": "Benutzern erlauben, eine Uhrzeit mit dem Datum anzugeben.",
        "date_format": "Datumsformat",
        "days_of_week": "Wochentage",
        "past_and_future": "Vergangenheit & Zukunft",
        "select_date_format": "Wählen Sie ein Datumsformat. D steht für Tag, M für Monat und Y für Jahr.",
        "select_dates_past_future": "Benutzern erlauben, Daten aus der Vergangenheit oder Zukunft auszuwählen",
        "select_time_format": "Wählen Sie ein Zeitformat",
        "time_format": "Zeitformat",
        "unchecking_day_calendar": "Das Abwählen eines Tages macht ihn im Kalender unzugänglich",
        "future": "Zukunft",
        "past": "Vergangenheit",
        "enter_maximum_limit": "Maximale Grenze eingeben",
        "enter_minimum_limit": "Minimale Grenze eingeben",
        "limit_minimum_or_maximum_value": "Beschränken Sie den minimalen oder maximalen Wert für dieses Feld",
        "maximum_limit_type_not_allowed_value": "Der eingegebene Wert für den Typ der maximalen Grenze ist kein erlaubter Wert.",
        "maximum_value_should_be_greater_than_minimum_value": "Der maximale Wert sollte größer als der minimale Wert sein",
        "minimum_limit_type_not_allowed_value": "Der eingegebene Wert für den Typ der minimalen Grenze ist kein erlaubter Wert.",
        "minimum_value_should_not_be_greater_than_maximum_value": "Der minimale Wert sollte nicht größer als der maximale Wert sein",
        "no_country_found": "Kein Land gefunden",
        "enter_maximum_limit_type": "Geben Sie den Typ der maximalen Grenze ein",
        "enter_minimum_limit_type": "Geben Sie den Typ der minimalen Grenze ein",
        "limit_minimum_or_maximum_text_allowed": "Beschränken Sie die minimale oder maximale Menge an Text, die in diesem Feld erlaubt ist",
        "max_should_be_greater_than_min": "Maximal sollte größer als Minimal sein",
        "min_should_be_less_than_max": "Minimal sollte kleiner als Maximal sein",
        "separator": "Trennzeichen",
        "countryCode": "Aktivieren Sie dies, um den Ländercode zu ändern."
    },
    "Category": {
        "cateory_name": "Kategoriename",
        "create_category": "Kategorie erstellen",
        "create_channel": "Kanal erstellen",
        "no_chat_found": "Keine Chats gefunden",
        "upgradeplanemsg": "Um auf diese Funktion zuzugreifen, bitte deinen Plan upgraden."
    },
    "Channel": {
        "create_channel": "Kanal erstellen",
        "msg1": "Du hast das maximale Limit für die Erstellung öffentlicher und privater Kanäle erreicht. Um auf diese Funktion zuzugreifen, bitte deinen Plan upgraden.",
        "channel_name": "Kanalname",
        "icons": "Symbole",
        "or": "oder",
        "only_share_with": "Nur teilen mit",
        "private_channel": "Privater Kanal",
        "msg2": "Nur ausgewählte Mitglieder und Rollen können diesen Kanal sehen",
        "allowmsg2": "Ermöglicht es Mitgliedern, Nachrichten in diesem Kanal zu senden",
        "send_messages": "Nachrichten senden",
        "choose_to_upload": "Wähle ein Bild zum Hochladen",
        "private_channel_limit_reached": "Du hast das Limit für die Erstellung privater Kanäle erreicht. Du kannst nur öffentliche Kanäle erstellen. Wenn du einen privaten Kanal erstellen möchtest, upgrade bitte deinen Plan.",
        "public_channel_limit_reached": "Du hast das Limit für die Erstellung öffentlicher Kanäle erreicht. Du kannst nur private Kanäle erstellen. Wenn du einen öffentlichen Kanal erstellen möchtest, upgrade bitte deinen Plan."
    },
    "Templates": {
        "delete_template": "Template löschen",
        "project_status": "Projektstatus",
        "task_status": "Aufgabenstatus",
        "no_app_selected": "Keine Apps ausgewählt",
        "default_views": "Standardansicht für Views",
        "apps": "Apps",
        "add_new_templete": "Neues Template hinzufügen",
        "templates": "Templates",
        "s": "s",
        "template_name": "Template-Name",
        "upload_image": "Bild hochladen",
        "all_good": "Alles gut",
        "create_template": "Template erstellen",
        "new_template": "Neues Template",
        "remove": "Entfernen",
        "enable_apps": "Apps aktivieren",
        "Turn": "Schalten",
        "all_apps": "alle Apps",
        "off": "aus",
        "on": "an",
        "upload": "Hochladen",
        "save_template": "Template speichern",
        "setup_status": "Status für Aufgaben einrichten",
        "what_task": "Welchen Aufgabenstatus möchtest du?",
        "select_task_status": "Aufgabenstatus auswählen",
        "delete_template_confirmation": "Bist du sicher, dass du das Template löschen möchtest?",
        "ai_sidebar_title": "Vorlage mit KI erstellen",
        "ai_label_category": "Kategorie",
        "ai_label_description": "Beschreibung",
        "ai_button_text_requested_changes": "Änderungen anfordern",
        "ai_min_view_msg_text": "Mindestens eine Ansicht erforderlich",
        "ai_min_msg_text": "Mindestens 10 Zeichen erforderlich",
        "ai_before_desc_placeholder": "Geben Sie eine Anwendungsbeschreibung ein, um eine Vorlage zu erstellen",
        "ai_after_desc_placeholder": "Hier können Sie weiterhin relevante Änderungen anfordern",
        "try_with_ai": "Mit KI versuchen",
        "msg_search_result_found": "Hier sind einige empfohlene Vorlagen, die zu Ihren Anforderungen passen. Sie können eine auswählen oder einfach klicken, um eine mit KI zu erstellen",
        "msg_search_result_not_found": "Keine relevanten Vorlagen gefunden. Um eine mit KI zu erstellen, klicken Sie einfach"
    },
    "Settings": {
        "add_new_projects": "Neues Projekt hinzufügen",
        "task_priority": "Aufgabenpriorität",
        "maximum_image_size": "Maximale Bildgröße",
        "warning": "Warnung",
        "cant_delete": "Kann nicht gelöscht werden",
        "priority_in_use": "Der Benutzer kann die PRIORITY_NAME-Priorität nicht löschen, da sie bereits verwendet wird.",
        "company_name": "Firmenname",
        "phone": "Telefon",
        "country": "Land",
        "state": "Bundesland",
        "city": "Stadt",
        "select_date_format": "Datum Format auswählen",
        "save_changes": "Änderungen speichern",
        "currencies": "Währungen",
        "add_remove_cur": "Währungen hinzufügen/entfernen",
        "change_image": "Bild ändern",
        "Priorities_already_Exists": "Prioritäten existieren bereits",
        "The_priority_image_field_is_required": "Das Prioritätsbildfeld ist erforderlich",
        "The_priority_name_field_is_required": "Das Prioritätsnamenfeld ist erforderlich",
        "The_priority_name_field_must_be_at_least": "Das Prioritätsnamenfeld muss mindestens 3 Zeichen enthalten",
        "The file extension field is required": "Das Dateierweiterungsfeld ist erforderlich",
        "The_file_extension_field_must_be_at_least": "Das Dateierweiterungsfeld muss mindestens 3 Zeichen enthalten",
        "file_extension_is_not_supported": "Dateierweiterung wird nicht unterstützt",
        "file_extension_already_Exists": "Dateierweiterung existiert bereits",
        "The_file_extension_field_is_required": "Das Dateierweiterungsfeld ist erforderlich."
    },
    "Members": {
        "invite": "Einladen",
        "all_members": "Alle Mitglieder",
        "removed_members": "Entfernte Mitglieder",
        "name": "Name",
        "role": "Rolle",
        "last_active": "Zuletzt aktiv",
        "time_tracker": "Zeiterfassung",
        "settings": "Einstellungen",
        "removeuser": "Benutzer entfernen",
        "adduser": "Benutzer hinzufügen",
        "invite_user": "Benutzer einladen",
        "remove_request": "Entfernungsanfrage",
        "resend_invitation": "Einladung erneut senden",
        "cancel_invitation": "Einladung stornieren",
        "Invitation_mail_sent_sucessfully": "Einladungs-E-Mail erfolgreich gesendet",
        "confirm_change_user_designation": "Bist du sicher, dass du die Bezeichnung dieses Benutzers auf ändern möchtest?",
        "confirm_change_user_role": "Bist du sicher, dass du die Rolle dieses Benutzers auf ändern möchtest?",
        "Import_users_from_csv": "Benutzer aus CSV importieren"
    },
    "Upgrades": {
        "take_next_step": "Mache den nächsten Schritt mit deiner Arbeit",
        "you_are_on": "Du befindest dich derzeit auf dem",
        "per_year": "Pro Jahr",
        "per_month": "Pro Monat",
        "current_plane": "Aktueller Plan",
        "per_member": "Pro Mitglied",
        "and_much_more": "und vieles mehr",
        "upgrade_to": "Upgrade auf",
        "select_payment_method": "Zahlungsmethode auswählen",
        "plan": "Plan",
        "plane_upgrade": "Plan erfolgreich upgraden",
        "plane_upgrade_msg": "Plan-Upgrade erfolgreich! Dein Abonnement wurde aktualisiert. Bitte warte 2 bis 3 Minuten, damit die Änderungen überall wirksam werden und du die erweiterten Funktionen und Verbesserungen vollständig nutzen kannst!",
        "something_wrong": "Etwas ist schief gelaufen. Bitte versuche es erneut.",
        "unsucessfull_msg": "Plan-Upgrade war nicht erfolgreich. Es gab ein Problem bei der Aktualisierung deines Plans. Bitte versuche es erneut oder kontaktiere den Support für Hilfe.",
        "upgrade_your_plan": "Upgrade deinen Plan",
        "to_unlock_custom_field": "Zum Freischalten des benutzerdefinierten Feldes",
        "unlimited": "Unbegrenzt",
        "the_feature_not_available": "Dieses Feature ist in deinem aktuellen Plan nicht verfügbar",
        "unlock_project_permission": "Zum Freischalten der Projektberechtigungen",
        "unlock_custom_field": "Zum Freischalten des benutzerdefinierten Feldes",
        "to_unlock_milestone": "Zum Freischalten von Meilensteinen",
        "to_unlock_milestone_report": "Zum Freischalten von Meilensteinberichten",
        "to_unlock_security": "Zum Freischalten von Sicherheit & Berechtigungen",
        "to_unlock_team": "Team entsperren",
        "to_unlcok_project": "Zum Freischalten des Projekts",
        "You_have_reached_the_free_plan_limit": "Sie haben das PLAN_NAME-Limit erreicht",
        "require_upgrade_message": "Sie können bis zu PROJECT_COUNT Projekte im PROJECT_NAME-Plan erstellen. Erstellen Sie weitere Boards, indem Sie Ihren Plan aktualisieren.",
        "are_you_sure_you_want_to_update": "Bist du sicher, dass du aktualisieren möchtest?",
        "find_out_whats_included_in_this_update": "Finde heraus, was in diesem Update enthalten ist",
        "improved_performance": "Verbesserte Leistung",
        "install_now": "Jetzt installieren",
        "later": "Später",
        "please_see_below_for_a_list_of_changes_to_the_features": "Siehe unten für eine Liste der Änderungen an den Funktionen.",
        "to_integrate_new_services_into_an_alian_hub": "Um neue Dienste in Hyphen OI Pro zu integrieren.",
        "whats_new": "Was ist neu?",
        "check_to_agree_with_above_points": "Aktiviere, um den oben genannten Punkten zuzustimmen",
        "general_notes": "Allgemeine Notizen",
        "update_now": "Jetzt aktualisieren",
        "unlock_channel": "Zum Freischalten des Kanals",
        "unlock_chat": "Zum Freischalten des Chats",
        "unlock_one_chat": "Zum Freischalten des Einzelchats",
        "public_private_creation_time_limit_reached": "Sie haben das Limit für die Projekterstellung erreicht. Wenn Sie ein Projekt erstellen möchten, aktualisieren Sie bitte Ihren Plan.",
        "public_creation_time_limit_reached": "Sie haben das Limit für die Erstellung öffentlicher Projekte erreicht. Sie können nur private Projekte erstellen. Wenn Sie ein öffentliches Projekt erstellen möchten, aktualisieren Sie bitte Ihren Plan.",
        "private_creation_time_limit_reached": "Sie haben das Limit für die Erstellung privater Projekte erreicht. Sie können nur öffentliche Projekte erstellen. Wenn Sie ein privates Projekt erstellen möchten, aktualisieren Sie bitte Ihren Plan."
    },
    "Permissions": {
        "advanced_permission": "Erweiterte Berechtigungen",
        "allow_admins": "Erlaube Admins, private Spaces zu verwalten",
        "when_admin_enable": "Wenn aktiviert, können Admins Personen hinzufügen/entfernen und die Eigentümerschaft aller Spaces übertragen.",
        "show_all_projects": "Alle Projekte anzeigen",
        "when_user_enable": "Wenn aktiviert, können Benutzer alle globalen Projekte sehen.",
        "show_all_task": "Alle Aufgaben anzeigen",
        "when_user_enable_sprint": "Wenn aktiviert, können Benutzer alle Aufgaben in den Sprints sehen.",
        "own": "Eigentum",
        "select": "Auswählen",
        "Member": "Mitglied",
        "Guest": "Gast",
        "None": "Keiner",
        "Read": "Lesen",
        "add_new_team": "Neues Team hinzufügen",
        "Read & Write": "Lesen & Schreiben",
        "Support": "Support",
        "select_priorities": "Prioritäten auswählen",
        "apply_permission": "Berechtigung anwenden",
        "project_permission_description": "Um die globalen Berechtigungen zu überschreiben, ist dies standardmäßig deaktiviert. Nachdem es aktiviert wurde, kannst du Projekt- und Aufgabenberechtigungen verwalten. Wenn es deaktiviert ist, werden die globalen Berechtigungen angewendet.",
        "project_permission_title_disable": "Die Möglichkeit, benutzerdefinierte Berechtigungen für dieses Projekt zu gewähren, wird deaktiviert.",
        "project_permission_title_enable": "Die Möglichkeit, benutzerdefinierte Berechtigungen für dieses Projekt zu gewähren, wird aktiviert.",
        "reset_permission": "Berechtigung zurücksetzen"
    },
    "subProjectRulesNames": {
        "Project_List": "Projektliste",
        "Project_Create": "Projekt erstellen",
        "Project_Name_Edit": "Projektname bearbeiten",
        "Project_Sprint_Create": "Projekt-Sprint erstellen",
        "Project_folder_Create": "Projektordner erstellen",
        "Project_folder_Name_Edit": "Projektordner Name bearbeiten",
        "Project_sprint_Name_Edit": "Projekt-Sprint Name bearbeiten",
        "Project_Details": "Projektdetails",
        "Project_Status_Change": "Projektstatus ändern",
        "Project_Assignee": "Projektzuweisung",
        "Project_Category": "Projektkategorie",
        "Proejct_Source": "Projektquelle",
        "Project_Type": "Projektart",
        "Project_Currency": "Projektwährung",
        "Project_Amount": "Projektbetrag",
        "Project_Start Date": "Projektstartdatum",
        "Project_End Date": "Projektenddatum",
        "Project_Due Date": "Projektfälligkeitsdatum",
        "Project_Close": "Projekt schließen",
        "Project_Description": "Projektbeschreibung",
        "Project_Checklist": "Projekt-Checkliste",
        "Project_Checklist_Assign/remove": "Projekt-Checkliste zuweisen/entfernen",
        "Project_Attachments": "Projektanhänge",
        "Project_Milestone": "Projektmeilenstein",
        "Task_list": "Aufgabenliste",
        "Task_Create": "Aufgabe erstellen",
        "Sub_Task_Create": "Unteraufgabe erstellen",
        "Task_Name_Edit": "Aufgabename bearbeiten",
        "Task_Status": "Aufgabenstatus",
        "Task_Assignee": "Aufgaben zuweisen",
        "Task_Priority": "Aufgabenpriorität",
        "Task_Due_Date": "Aufgabefälligkeitsdatum",
        "Task_Estimated_Hours": "Aufgaben geschätzte Stunden",
        "Task_Description": "Aufgabenbeschreibung",
        "Task_Checklist": "Aufgaben-Checkliste",
        "Task_Checklist_Assign/remove": "Aufgaben-Checkliste zuweisen/entfernen",
        "Task_Attachments": "Aufgabenanhänge",
        "Show_Tasks": "Aufgaben anzeigen",
        "Custom_Field": "Benutzerdefiniertes Feld",
        "Edit_Company": "Firma bearbeiten",
        "File_Extensions": "Dateierweiterungen",
        "Project_Milestone_Status": "Projektmeilenstein-Status",
        "Invite_Member": "Mitglied einladen",
        "Member_list": "Mitgliederliste",
        "Create_Team": "Team erstellen",
        "Team_List": "Teamliste",
        "Security_&_Permissions": "Sicherheit & Berechtigungen",
        "Role_Management": "Rollenmanagement",
        "Designation": "Bezeichnung",
        "Milestone_Weekly_Range": "Meilenstein wöchentliche Reichweite",
        "User_Timesheet": "Benutzungszeiterfassung",
        "Project_Timesheet": "Projektzeiterfassung",
        "Workload__Timesheet": "Arbeitslast Zeiterfassung",
        "Milestone_Report": "Meilensteinbericht",
        "Project": "Projekt",
        "Task": "Aufgabe",
        "Company_Settings": "Firmeneinstellungen",
        "Sheet_Settings": "Tabelleneinstellungen",
        "Team_Color": "Teamfarbe",
        "Team_Name": "Teamnamen",
        "Add_Member": "Mitglied hinzufügen",
        "Add_New_Designation": "Neue Bezeichnung hinzufügen"
    },
    "Notification": {
        "Notification": "Benachrichtigung",
        "notification_setting": "Benachrichtigungseinstellungen",
        "browser": "Browser",
        "mobile": "Mobil",
        "before": "Vor",
        "chat": "Chat",
        "project": "Projekt",
        "tasks": "Aufgaben",
        "before_project_due_date": "Projektfälligkeitsdatum",
        "before_project_end_date": "Projektenddatum",
        "before_task_due_date": "Aufgabefälligkeitsdatum",
        "before_task_end_date": "Aufgabenenddatum",
        "message_create": "Nachricht erstellen",
        "project_create": "Projekt erstellen",
        "project_name": "Projektname",
        "project_status_change": "Projektstatus ändern",
        "project_assignee": "Projektzuweisung",
        "project_lead": "Projektleiter",
        "project_category": "Projektkategorie",
        "project_source": "Projektquelle",
        "project_type": "Projektart",
        "project_currency": "Projektwährung",
        "project_amount": "Projektbetrag",
        "project_start_date": "Projektstartdatum",
        "project_end_date": "Projektenddatum",
        "project_due_date": "Projektfälligkeitsdatum",
        "project_close": "Projekt schließen",
        "project_description": "Projektbeschreibung",
        "project_checklist": "Projekt-Checkliste",
        "project_checklist_assign": "Projekt-Checkliste zuweisen",
        "project_checklist_remove": "Projekt-Checkliste entfernen",
        "project_attachments": "Projektanhänge",
        "project_milestone": "Projektmeilenstein",
        "project_milestone_status_change": "Projektmeilenstein-Status ändern",
        "project_sprint_create": "Projekt-Sprint erstellen",
        "project_folder_create": "Projektordner erstellen",
        "comments_im_@mentioned_in": "Kommentare, in denen ich mit {@} erwähnt wurde",
        "task_notification": "Aufgabenbenachrichtigung",
        "task_create": "Aufgabe erstellen",
        "task_edit": "Aufgabe bearbeiten",
        "task_status": "Aufgabenstatus",
        "task_assignee": "Aufgaben zuweisen",
        "task_priority": "Aufgabenpriorität",
        "task_type": "Aufgabentyp",
        "task_due_date": "Aufgabefälligkeitsdatum",
        "task_description": "Aufgabenbeschreibung",
        "task_checklist": "Aufgaben-Checkliste",
        "task_checklist_assign": "Aufgaben-Checkliste zuweisen",
        "task_checklist_remove": "Aufgaben-Checkliste entfernen",
        "task_attachments": "Aufgabenanhänge",
        "comments_Im_@mentioned_in": "Kommentare, in denen ich mit {@} erwähnt wurde",
        "logged_hours_notification": "Protokollierte Stunden Benachrichtigung",
        "after_3_hours_today_pending_hours": "Nach 3 Stunden Heute ausstehende Stunden Benachrichtigung",
        "task_estimated_hours": "Geschätzte Stunden der Aufgabe"
    },
    "TimeTracker": {
        "TimeTracker": "Zeiterfassung",
        "unlock": "Schalte das Universum mit dem Hyphen OI Pro Tracker auf deinem Desktop frei!",
        "smooth": "Verfolge problemlos die Stunden, die Benutzer mit der Arbeit an Projekten oder Aufgaben verbringen.",
        "click": "Klicken",
        "No_Record_Found": "Kein Eintrag gefunden",
        "total": "Gesamt",
        "screenshot_preview": "Screenshot-Vorschau",
        "log_time_found_no_screenshot": "Es wurden Log-Zeiten gefunden, aber für diese Dauer wurde kein Screenshot erfasst."
    },
    "settingslider": {
        "Time Tracking": "Zeiterfassung",
        "Notifications": "Benachrichtigungen",
        "Company": "Firma",
        "My Settings": "Meine Einstellungen",
        "Security & Permissions": "Sicherheit & Berechtigungen",
        "Upgrade": "Upgrade",
        "Custom Field Manager": "Benutzerdefinierter Feldmanager",
        "Templates": "Templates",
        "Projects": "Projekte",
        "Teams": "Teams",
        "Members": "Mitglieder",
        "Settings": "Einstellungen",
        "Change Password": "Kennwort ändern"
    },
    "Chat": {
        "welcome_message": "Willkommen bei BRAND_NAME",
        "msg2": "Dies ist eine brandneue Gruppe. Hier sind einige Schritte, die dir beim Einstieg helfen. Weitere Informationen findest du in unserem Einstiegshandbuch",
        "chats": "Chats",
        "favorites": "Favoriten",
        "CHANNELS": "KANÄLE"
    },
    "Comments": {
        "unread_message": "Ungelesene Nachrichten",
        "more": "mehr",
        "less": "weniger",
        "edited": "bearbeitet",
        "edit": "Bearbeiten",
        "create_task": "Aufgabe erstellen",
        "add_to_checklist": "Zur Checkliste hinzufügen",
        "copy_message": "Nachricht kopieren",
        "reply": "Antworten",
        "message": "Nachricht",
        "mark_unread": "Als ungelesen markieren",
        "This_message_is_deleted": "Diese Nachricht wurde gelöscht",
        "You_deleted_this_message": "Du hast diese Nachricht gelöscht",
        "no_user_found": "Kein Benutzer gefunden",
        "unlock_comment_view": "Um die Kommentaransicht freizuschalten"
    },
    "PlaceHolder": {
        "enter_task_type": "Aufgabentyp eingeben",
        "enter_task_status": "Aufgabenstatus eingeben",
        "enter_project_status": "Projektstatus eingeben",
        "Enter_Project_Name": "Projektname eingeben",
        "Enter_Key_Name": "Schlüsselname eingeben",
        "Select_Category": "Kategorie auswählen",
        "Select_Project_Due_Date": "Projektfälligkeit auswählen",
        "search": "Suchen",
        "search_here": "Hier suchen",
        "Type_here": "Hier tippen",
        "Task_name": "Aufgabenname",
        "Add_description": "Beschreibung hinzufügen",
        "Enter_Duplicate_Task_Name": "Doppelte Aufgabenbezeichnung eingeben",
        "Enter_Text": "Text eingeben",
        "Enter_Amount": "Betrag eingeben",
        "Select": "Auswählen",
        "Enter_Refund_Amount": "Rückerstattungsbetrag eingeben",
        "Enter_Milestone_Name": "Meilensteinname eingeben",
        "Enter_sprint_name": "Sprintname eingeben",
        "Enter_directory_name": "Verzeichnisname eingeben",
        "Rename_Tag": "Tag umbenennen",
        "Enter_Team_Name": "Teamname eingeben",
        "Duration_only_hours": "Dauer nur Stunden",
        "Enter_option": "Option eingeben",
        "Enter_View_Name": "Ansichtsname eingeben",
        "Enter_URL": "URL eingeben",
        "Enter_HTML": "HTML eingeben",
        "Enter_item_name": "+ Artikelnamen eingeben",
        "Add_an_item": "+ Einen Artikel hinzufügen",
        "Enter_Company_Name": "Firmennamen eingeben",
        "Select_Country": "Land auswählen",
        "Enter_Template": "Vorlage eingeben",
        "Enter_Template_Name": "Vorlagenname eingeben",
        "Project_key_must_be_unique": "Der Projektschlüssel muss eindeutig sein",
        "Enter_zip": "Postleitzahl eingeben",
        "Enter_GST_Number": "GST-Nummer eingeben",
        "Enter_Milestone_Status": "Meilensteinstatus eingeben",
        "Enter_Priority_Name": "Prioritätsname eingeben",
        "Enter_File_Extensions_Name": "Dateierweiterungsname eingeben",
        "Enter_Task_Name": "Aufgabename eingeben",
        "Select_State": "Bundesland auswählen",
        "No_States": "Keine Bundesländer",
        "Select_City": "Stadt auswählen",
        "No_Cities": "Keine Städte",
        "enter_category_name": "Kategorinamen eingeben",
        "enter_channel_name": "Kanalnamen eingeben",
        "Pinned_messages": "Fixierte Nachrichten",
        "Search": "Suchen",
        "Search_by_name_or_email": "Nach Name oder E-Mail suchen",
        "Invite_by_email": "Per E-Mail einladen",
        "Select_Designation": "Bezeichnung auswählen",
        "Select_Role": "Rolle auswählen",
        "Enter_designation": "Bezeichnung eingeben",
        "Enter_Description": "Beschreibung eingeben",
        "Add_New_Role": "Neue Rolle hinzufügen",
        "Enter_role": "Rolle eingeben",
        "Enter_Field_Label": "Feldbezeichnung eingeben",
        "Enter_Placeholder": "Platzhalter eingeben",
        "field_label": "Feldbezeichnung",
        "placeholder": "Platzhalter",
        "Enter_Number": "Nummer eingeben"
    },
    "DuplicateTask": {
        "duplicate_task_name": "Doppelte Aufgabenbezeichnung",
        "what_do_you_copy": "Was möchtest du kopieren",
        "everything": "Alles",
        "no_assignee": "Kein Zuordner",
        "no_watcher": "Kein Beobachter",
        "move_task": "Aufgabe verschieben",
        "mearge_task_into": "Aufgabe zusammenführen in"
    },
    "Converttolist": {
        "are_you_sure_convert": "Bist du sicher, dass du diese Aufgabe in eine Liste umwandeln möchtest?",
        "important": "Wichtig",
        "you_will_lose": "Du wirst alle verschachtelten Kommentare verlieren. Diese Aktion kann nicht rückgängig gemacht werden",
        "convert_to_list": "In Liste umwandeln"
    },
    "Billing": {
        "billing_details": "Rechnungsdetails",
        "plan_details": "Plan Details",
        "next_msg": "Der nächste fällige Betrag ist",
        "due_on": "Fällig am",
        "upgrade_plan": "Plan upgraden",
        "cancel_subscription": "Abonnement kündigen",
        "reactivate_subscription": "Abonnement reaktivieren",
        "biling_info": "Rechnungsinformationen",
        "update_billing_info": "Rechnungsinformationen aktualisieren",
        "contact_support": "Support kontaktieren",
        "for_help_msg": "Für Hilfe und Unterstützung bei deinen Rechnungsfragen kontaktiere unser Support-Team, sie helfen dir gerne weiter.",
        "payment_methods": "Zahlungsmethoden",
        "update_payment_method": "Zahlungsmethode aktualisieren",
        "add_payment_method": "Zahlungsmethode hinzufügen",
        "ending_in": "läuft aus am",
        "payment_method_update": "Zahlungsmethode erfolgreich aktualisiert.",
        "waiting_msg": "Deine kürzliche Aktualisierung der Zahlungsmethode wird mit deiner nächsten Rechnung wirksam und für alle zukünftigen Zahlungen verwendet.",
        "error_updating": "Aktualisierung der Zahlungsmethode fehlgeschlagen. Wir haben ein Problem bei der Aktualisierung deiner Zahlungsmethode festgestellt. Bitte versuche es erneut oder kontaktiere den Support für Hilfe.",
        "card_expires": "Karte läuft aus am",
        "billing_address": "Rechnungsadresse",
        "subscription_plan": "Abonnementplan",
        "next_renew_date": "Nächstes Erneuerungsdatum",
        "storage_use": "Speicherverbrauch",
        "address": "Adresse",
        "address_line": "Adresszeile",
        "zip_code": "Postleitzahl",
        "zip": "Postleitzahl",
        "Save_&_Continue": "Speichern & Weiter",
        "billing_history": "Rechnungsverlauf",
        "Invoices": "Rechnungen",
        "credit_notes": "Gutschriften",
        "download": "Herunterladen",
        "id": "ID",
        "type": "Typ",
        "date": "Datum",
        "description": "Beschreibung",
        "no_of_users": "Anzahl der Benutzer",
        "amount": "Betrag",
        "status": "Status",
        "pay_now": "Jetzt bezahlen",
        "cancelling_subscription_message": "Das Kündigen des Abonnements bedeutet, dass dein Abonnement endet am",
        "reactivate_anytime": "Jederzeit reaktivieren!",
        "reactivate_confirmation": "Bist du sicher, dass du das Abonnement reaktivieren möchtest? Wenn du 'Ja' auswählst, wird dein Abonnement reaktiviert und dein Zahlungsplan fortgesetzt.",
        "amounting_to": "Betrag in Höhe von",
        "insufficient_funds": "Unzureichende Mittel",
        "payment_successful": "Zahlung erfolgreich.",
        "payment_successful_details": "Zahlung erfolgreich! Deine Rechnung ist bezahlt. Bitte warte 2 bis 3 Minuten, damit die Änderungen überall wirksam werden und du die erweiterten Funktionen genießen kannst.",
        "payment_unsuccessful": "Zahlung fehlgeschlagen. Es gab ein Problem bei der Aktualisierung deines Plans. Bitte versuche es erneut oder kontaktiere den Support für Unterstützung.",
        "plan_upgrade_unsuccessful": "Upgrade des Plans fehlgeschlagen. Es gab ein Problem bei der Aktualisierung deines Plans. Stelle bitte sicher, dass die Karte ausreichend gedeckt ist.",
        "proceed_with_payment": "Möchtest du mit der Zahlung für die Rechnung fortfahren?",
        "attention_needed": "Wir benötigen deine Aufmerksamkeit!",
        "avoid_service_disruption": "um eine Unterbrechung des Dienstes zu vermeiden",
        "subscription_renewal_failed": "Die automatische Verlängerung des Abonnements ist fehlgeschlagen aufgrund von",
        "update_payment_method_please": "Bitte aktualisiere deine Zahlungsmethode",
        "click_here_for_update_payment_method": "Hier klicken, um Zahlungsmethode zu aktualisieren",
        "credit_balance": "Kreditguthaben",
        "this_balance_will_be_used_for_a_future_payment": "Dieses Guthaben wird für eine zukünftige Zahlung verwendet.",
        "paymnet_failed_subscription_canceled": "Wir möchten Sie darüber informieren, dass Ihr vorheriges Abonnement gekündigt wurde. Ihr Konto wurde nun auf unser Standardabonnement umgestellt, bei dem einige Funktionen deaktiviert sind. Um diese Funktionen zu aktivieren, aktualisieren Sie bitte Ihren Plan.",
        "promotional_credit_balance": "Werbeguthaben",
        "balance": "Guthaben",
        "created_on": "Erstellt am",
        "no_promotional_found": "Keine Werbeguthaben-Historie gefunden"
    },
    "Tour": {
        "tour_completed": "Tour abgeschlossen",
        "do_you_have_any": "Haben Sie Fragen? Wir empfehlen Ihnen, unsere umfassenden Video-Tutorials von BRAND_NAME zu erkunden, um loszulegen und das Beste aus Ihrer Erfahrung herauszuholen.",
        "watch_video": "Video ansehen",
        "have_brief_tour_alianhub": "Möchten Sie eine kurze Tour durch BRAND_NAME machen?",
        "have_brief_tour_alianhub_view": "Möchten Sie eine kurze Tour durch die Ansichten von BRAND_NAME machen?",
        "have_brief_tour_alianhub_left_side": "Möchten Sie eine kurze Tour durch die Projektliste machen?",
        "look_how_to_create": "Sehen Sie, wie Sie ein Projekt erstellen, Aufgaben verwalten, Zeitblätter anzeigen, einen Chat betreten, Erwähnungen und Benachrichtigungen ansehen und mehr.",
        "lets_start": "Lass uns anfangen",
        "no_thanks": "Nein, danke",
        "have_brief_task": "Möchten Sie eine kurze Tour durch Aufgaben machen?",
        "have_brief_tour_project": "Möchten Sie eine kurze Tour durch das Projekt machen?",
        "look_how_to_create_task": "Sehen Sie, wie Sie eine Aufgabe erstellen, Aufgaben verwalten, Aufgaben nach Status gruppiert anzeigen und mehr.",
        "look_how_to_create_project": "Sehen Sie, wie Sie ein Projekt erstellen, Projekte verwalten, Aufgaben nach Status gruppiert anzeigen und mehr.",
        "project_creation_description": "Projekte können mühelos erstellt, zugewiesen und verfolgt werden, mit klarer Sicht auf die Verantwortlichkeiten der Teammitglieder. Dies fördert eine bessere Organisation, die zu erhöhter Effizienz und Produktivität führt. Klicken Sie hier, um ein neues Projekt zu starten.",
        "enter_project_name": "Bitte geben Sie einen kurzen Namen für Ihr Projekt ein.",
        "enter_project_key": "Bitte geben Sie einen kurzen Schlüssel für Ihr Projekt ein.",
        "add_project_category": "Bitte fügen Sie eine Kategorie für Ihr Projekt hinzu.",
        "enter_project_duedate": "Bitte geben Sie ein Fälligkeitsdatum für Ihr Projekt ein.",
        "add_project_lead_assignee": "Bitte fügen Sie einen leitenden Beauftragten für Ihr Projekt hinzu.",
        "create_project_from_template": "Mit dieser Option können Sie schnell ein neues Projekt mithilfe einer bestehenden Vorlage erstellen, die mit vorkonfigurierten Daten und Einstellungen ausgestattet ist, sodass Sie die gleiche Projektkonfiguration einfach replizieren können.",
        "customize_project_section": "Mit dieser Option können Sie Ihr Projekt vollständig personalisieren, indem Sie verschiedene Elemente wie Status, Typen, Apps und mehr einrichten, die speziell auf Ihre Bedürfnisse zugeschnitten sind.",
        "task_type_templates_list_text": "Liste der Aufgaben-Vorlagentypen",
        "task_type_templates_description_text": "Dieser Bereich zeigt verfügbare Aufgaben-Vorlagentypen an. Wählen Sie denjenigen aus, der Ihren Anforderungen entspricht.",
        "create_new_task_type_template_text": "Neue Aufgaben-Vorlagentyp erstellen",
        "create_new_task_type_template_description_text": "Klicken Sie auf die Schaltfläche +, um eine neue Aufgaben-Vorlage hinzuzufügen, die Sie dann für Ihre Aufgaben verwenden können.",
        "view_template_task_types_text": "Vorlagen-Aufgabentypen anzeigen",
        "view_template_task_types_description_text": "Hier können Sie die mit der ausgewählten Vorlage verknüpften Aufgabentypen anzeigen. Sie können diese ändern oder neue Aufgabentypen hinzufügen, die Ihren Anforderungen entsprechen.",
        "add_new_task_type_text": "Neuen Aufgabentyp hinzufügen",
        "add_new_task_type_description_text": "Klicken Sie auf die Schaltfläche 'Aufgabentyp hinzufügen', um neue Aufgabentypen in die ausgewählte Vorlage einzufügen.",
        "save_project_as_template_text": "Projekt als Vorlage speichern",
        "save_project_as_template_description_text": "Klicken Sie auf 'Als Vorlage speichern', um die aktuelle Konfiguration für die zukünftige Verwendung zu speichern.",
        "initiate_new_project_text": "Neues Projekt starten",
        "initiate_new_project_description_text": "Klicken Sie hier, um ein neues Projekt zu starten.",
        "add_new_task_text": "Neue Aufgabe hinzufügen",
        "input_task_name_text": "Aufgabenname eingeben",
        "choose_task_status_text": "Aufgabenstatus wählen",
        "assign_task_text": "Aufgabe zuweisen",
        "set_task_deadline_text": "Aufgabendeadline festlegen",
        "define_task_priority_text": "Aufgabenpriorität definieren",
        "view_task_list_text": "Aufgabenliste anzeigen",
        "task_information_text": "Aufgabeninformation",
        "quick_task_menu_text": "Schnellaufgabenmenü",
        "task_actions_text": "Aufgabenaktionen",
        "subtask_toggle_text": "Unteraufgaben-Umschalter",
        "task_tour_complete_text": "Aufgabentour abgeschlossen",
        "create_new_task_description_text": "Erstellen Sie eine neue Aufgabe, indem Sie auf die Schaltfläche '+ Neue Aufgabe' klicken.",
        "input_task_name_description_text": "Geben Sie den Namen der Aufgabe in das vorgesehene Eingabefeld ein.",
        "choose_task_status_description_text": "Wählen Sie den entsprechenden Aufgabentyp aus, der Ihren Anforderungen entspricht.",
        "assign_task_description_text": "Wählen Sie die Person aus, der die Aufgabe zugewiesen wird.",
        "set_task_deadline_description_text": "Wählen Sie ein Fälligkeitsdatum für die Aufgabe aus.",
        "define_task_priority_description_text": "Wählen Sie die Prioritätsstufe für die Aufgabe aus.",
        "view_task_list_description_text": "Dies ist eine Liste der Aufgaben, die deren Details anzeigen und nach Status gruppiert sind.",
        "task_information_description_text": "Hier sind die Details zur ausgewählten Aufgabe."
    },
    "TaskStatus": {
        "To_Do": "Zu erledigen"
    },
    "AI": {
        "generate": "Generieren",
        "ai_button": "Mit KI schreiben",
        "ai_title": "Bitten Sie KI, alles zu finden oder zu erstellen",
        "write_with_ai": "Mit KI schreiben",
        "suggest_tasks": "Aufgaben vorschlagen",
        "suggest_subtasks": "Unteraufgaben vorschlagen",
        "ai_sidebar_placeholder": "Worüber soll die KI schreiben?",
        "ai_chat_placeholder": "Sagen Sie der KI, was als Nächstes zu tun ist",
        "ai_available_on_paid_plans_upgrade_now": "KI ist nur bei unseren kostenpflichtigen Plänen erhältlich. Jetzt upgraden und KI hinzufügen!",
        "please_upgrade_plan_to_use_ai": "Bitte upgraden Sie Ihren Plan, um KI zu nutzen.",
        "read_less": "Weniger lesen",
        "read_more": "Mehr lesen",
        "to_unlock_ai": "Um KI freizuschalten",
        "copy": "Kopieren",
        "generating_results": "Ergebnisse werden generiert",
        "hub_ai": "HubAI",
        "regenerate": "Neu generieren",
        "title": "Titel",
        "error_occurred_engine_issue": "Ein Fehler ist aufgetreten. Entweder existiert die angeforderte Engine nicht oder es gab ein anderes Problem bei der Verarbeitung Ihrer Anfrage.",
        "ai_not_integrated": "KI ist in Ihrem System nicht integriert.",
        "limit_reached": "Sie haben Ihr Limit erreicht."
    },
    "Toast": {
        "Your_card_is_expired": "Ihre Karte ist abgelaufen.",
        "Password_set_new_has_been_successfully": "Das neue Passwort wurde erfolgreich gesetzt.",
        "task_created_successfully": "Aufgabe erfolgreich erstellt",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": "Bitte entfernen Sie den erweiterten Filter, um neu erstellte Projekte anzuzeigen.",
        "create_task_plan_limit_message": "Aktualisieren Sie Ihren Plan. Sie haben das Limit für die Erstellung von Aufgaben im TASK_SPRINT-Sprint erreicht.",
        "something_went_wrong": "Etwas ist schiefgelaufen.",
        "file_size_is_larger_than_maxFileSize": "Die Dateigröße ist größer als die maximale Dateigröße.",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "Wählen Sie nur Bilder aus, und das Dateiformat sollte FILE_FORMATS sein.",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "Wählen Sie nur Dateien aus, und das Dateiformat sollte FILE_FORMATS sein.",
        "Multiple_files_not_allowed": "Mehrere Dateien sind nicht erlaubt.",
        "Please_select_valid_file": "Bitte wählen Sie eine gültige Datei aus.",
        "require_image_format_message": "Das Dateiformat wird nicht unterstützt oder wurde nicht in den Unternehmenseinstellungen hinzugefügt. Sie können das Dateiformat in den Einstellungen hinzufügen.",
        "You_have_to_add_extension_in_setting": "Sie müssen die Erweiterung in den Einstellungen hinzufügen.",
        "Something_went_wrong_Please_try_again": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        "Company_is_disable": "Das Unternehmen ist deaktiviert.",
        "advance_search_feature_upgrade_message": "Diese Funktion \"Erweiterte Suche\" ist in Ihrem aktuellen Plan nicht verfügbar. Um die erweiterte Suche freizuschalten, aktualisieren Sie Ihren Plan.",
        "Access_Denied": "Zugriff verweigert",
        "notification_permission": "Um Benachrichtigungen zu erhalten, erlauben Sie bitte die Benachrichtigungsberechtigung in den Seiteneinstellungen und laden Sie die Seite erneut.",
        "Link_is_Copied_to_clipboard": "Link wurde in die Zwischenablage kopiert.",
        "Task_Key_is_Copied_to_clipboard": "Aufgabenschlüssel wurde in die Zwischenablage kopiert.",
        "At_least_one_field_is_required": "Mindestens ein Feld ist erforderlich.",
        "Task_name_updated_successfully": "Aufgabenname erfolgreich aktualisiert",
        "Watcher_added_successfully": "Beobachter erfolgreich hinzugefügt",
        "Watcher_removed_successfully": "Beobachter erfolgreich entfernt",
        "Nothing_to_update": "Nichts zu aktualisieren",
        "Sprint_created_successfully": "Sprint erfolgreich erstellt",
        "Sprint_restored_successfully": "Sprint erfolgreich wiederhergestellt",
        "Sprint_closed_successfully": "Sprint erfolgreich geschlossen",
        "Sprint_archived_successfully": "Sprint erfolgreich archiviert",
        "Sprint_deleted_successfully": "Sprint erfolgreich gelöscht",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "Aktualisieren Sie Ihren Plan. Sie haben das Limit für die Erstellung von Sprints erreicht.",
        "Folder_created_successfully": "Ordner erfolgreich erstellt",
        "Folder_updated_successfully": "Ordner erfolgreich aktualisiert",
        "Folde_restored_successfully": "Ordner erfolgreich wiederhergestellt",
        "Folder_closed_successfully": "Ordner erfolgreich geschlossen",
        "Folder_archived_successfully": "Ordner erfolgreich archiviert",
        "Folder_deleted_successfully": "Ordner erfolgreich gelöscht",
        "Status_changed_successfully": "Status erfolgreich geändert",
        "Due_date_updated_successfully": "Fälligkeitsdatum erfolgreich aktualisiert",
        "Due_date_not_updated": "Fälligkeitsdatum nicht aktualisiert",
        "Assignee_changed_successfully": "Zuständigkeit erfolgreich geändert",
        "Assignee_added_successfully": "Zuständigkeit erfolgreich hinzugefügt",
        "Assignee_removed_successfully": "Zuständigkeit erfolgreich entfernt",
        "Assignee_not_updated": "Zuständigkeit nicht aktualisiert",
        "Task_updated_successfully": "Aufgabe erfolgreich aktualisiert",
        "Task_restored_successfully": "Aufgabe erfolgreich wiederhergestellt",
        "Task_archived_successfully": "Aufgabe erfolgreich archiviert",
        "Task_deleted_successfully": "Aufgabe erfolgreich gelöscht",
        "Tag_Deleted_successfully": "Tag erfolgreich gelöscht",
        "Log_time_added_successfully": "Zeiterfassung erfolgreich hinzugefügt.",
        "Filter_saved_successfully": "Filter erfolgreich gespeichert.",
        "Filter_update_successfully": "Filter erfolgreich aktualisiert.",
        "Filter_deleted_successfully": "Filter erfolgreich gelöscht.",
        "Checklist_created_successfully": "Checkliste erfolgreich erstellt.",
        "Please_select_checklist": "Bitte wählen Sie eine Checkliste aus.",
        "already_exists": "EXIST_VALUE existiert bereits.",
        "Converted_successfully": "Erfolgreich konvertiert",
        "create_task_limit_in_sprint_upgrade_task_message": "Aktualisieren Sie Ihren Plan. Sie haben das Limit für die Erstellung von Aufgaben im Sprint SELECTED_SPRINT_DATA erreicht.",
        "Please_Select_Task_Type": "Bitte wählen Sie den Aufgabentyp aus.",
        "Please_Select_Task": "Bitte wählen Sie eine Aufgabe aus.",
        "Task_moved_successfully": "Aufgabe erfolgreich verschoben",
        "Task_not_moved": "Aufgabe nicht verschoben",
        "Task_duplicate_successfully": "Aufgabe erfolgreich dupliziert",
        "Task_not_duplicated": "Aufgabe nicht dupliziert",
        "Convert_in_to_task_successfully": "Erfolgreich in Aufgabe umgewandelt",
        "Company_name_already_exists": "Der Unternehmensname existiert bereits.",
        "Company_has_been_created_Successfully": "Unternehmen wurde erfolgreich erstellt.",
        "Custom_field_updated_successfully": "Benutzerdefiniertes Feld erfolgreich aktualisiert",
        "No_assignee_found": "Keine Zuständigkeit gefunden",
        "No_due_date_found": "Kein Fälligkeitsdatum gefunden",
        "No_self_assignee_found": "Keine Selbstzuweisung gefunden",
        "Estimated_time_updated_successfully": "Geschätzte Zeit erfolgreich aktualisiert",
        "Description_updated_successfully": "Beschreibung erfolgreich aktualisiert",
        "Description_not_updated": "Beschreibung nicht aktualisiert",
        "Copied": "Kopiert!",
        "User_removed_successfully": "Benutzer erfolgreich entfernt",
        "Invitation_cancelled_successfully": "Einladung erfolgreich storniert",
        "User_role_changed_successfully": "Benutzerrolle erfolgreich geändert",
        "User_designation_changed_successfully": "Benutzerbezeichnung erfolgreich geändert.",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "Bitte aktualisieren Sie Ihren Plan, um den Zeit-Tracker zu verwenden.",
        "Request_remove_successfully": "Anfrage erfolgreich entfernt",
        "Upgrade_Your_Plan": "Aktualisieren Sie Ihren Plan",
        "Updated_successfully": "Erfolgreich aktualisiert",
        "Deleted_successfully": "Erfolgreich gelöscht",
        "View_Pinned": "Fixierte Ansicht",
        "View_Unpinned": "Nicht fixierte Ansicht",
        "View_Already_Added": "Ansicht bereits hinzugefügt",
        "Company_details_saved_successfully": "Unternehmensdetails erfolgreich gespeichert.",
        "Currency_added_successfully": "Währung erfolgreich hinzugefügt",
        "Currency_removed_successfully": "Währung erfolgreich entfernt",
        "File_extension_remove_successfully": "Dateierweiterung FILE_EXTENSION erfolgreich entfernt",
        "File_extension_update_successfully": "Dateierweiterung erfolgreich aktualisiert.",
        "Project_milestone_status_updated_successfully": "Projekt-Meilensteinstatus erfolgreich aktualisiert.",
        "Status_updated_successfully": "Status erfolgreich aktualisiert.",
        "Project_milestone_status_Deleted_successfully": "Projekt-Meilensteinstatus erfolgreich gelöscht.",
        "Milestone_weekly_range_updated_successfully": "Wöchentlicher Bereich des Meilensteins erfolgreich aktualisiert.",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "Die Bildabmessungen dürfen ImageDimensions Pixel nicht überschreiten.",
        "error_in_uploading_image_please_try_it_again": "Fehler beim Hochladen des Bildes, bitte versuchen Sie es erneut.",
        "Task_priority_updated_successfully": "Aufgabenpriorität erfolgreich aktualisiert.",
        "Task_priority_Remove_successfully": "Aufgabenpriorität erfolgreich entfernt.",
        "Priority_updated_successfully": "Priorität erfolgreich aktualisiert.",
        "Priority_not_updated": "Priorität nicht aktualisiert.",
        "error_in_deleting_priority_please_try_it_again": "Fehler beim Löschen der Priorität, bitte versuchen Sie es erneut.",
        "Field_Enable_Successfully": "Feld erfolgreich aktiviert.",
        "Field_Disable_Successfully": "Feld erfolgreich deaktiviert.",
        "Field_Added_Successfully": "Feld erfolgreich hinzugefügt.",
        "Field_Updated_Successfully": "Feld erfolgreich aktualisiert.",
        "Added_to_favourite": "Zu Favoriten hinzugefügt.",
        "Removed_from_favourite": "Aus Favoriten entfernt.",
        "Tag_Created_successfully": "Tag erfolgreich erstellt.",
        "Queue_list_added_successfully": "Wartelistenpunkt erfolgreich hinzugefügt.",
        "Queue_list_removed_successfully": "Wartelistenpunkt erfolgreich entfernt.",
        "Queue_list_not_updated": "Wartelistenpunkt nicht aktualisiert.",
        "Attachments_uploaded_successfully": "Anhänge erfolgreich hochgeladen.",
        "Attachment_removed_successfully": "Anhang erfolgreich entfernt.",
        "Attachment_not_removed": "Anhang nicht entfernt.",
        "Please_try_again": "Bitte versuchen Sie es erneut.",
        "Task_name_copied": "Aufgabenname kopiert.",
        "Status_already_exists": "Status existiert bereits.",
        "Status_added_successfully": "Status erfolgreich hinzugefügt.",
        "Task_Type_already_exists": "Aufgabentyp existiert bereits.",
        "Task_Type_added_successfully": "Aufgabentyp erfolgreich hinzugefügt.",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "Die Bildgröße muss kleiner als ImageDimensions Pixel sein.",
        "Data_deleted_successfully": "Daten erfolgreich gelöscht.",
        "Category_created_successfully": "Kategorie erfolgreich erstellt.",
        "Please_select_an_image_file": "Bitte wählen Sie eine Bilddatei aus.",
        "Channel_created_successfully": "Kanal erfolgreich erstellt.",
        "Folder_not_found": "Ordner nicht gefunden.",
        "Template_&_Project_data_has_been_added_successfully": "Vorlagen- und Projektdaten wurden erfolgreich hinzugefügt.",
        "Project_data_has_been_added_successfully": "Projektdaten wurden erfolgreich hinzugefügt{filterMessage}",
        "Error_in_creating_project": "Fehler beim Erstellen des Projekts.",
        "Milestone_deleted_successfully": "Meilenstein erfolgreich gelöscht.",
        "Error_in_deleting_milestone": "Fehler beim Löschen des Meilensteins.",
        "Milestone_added_successfully": "Meilenstein erfolgreich hinzugefügt.",
        "Error_in_adding_milestone": "Fehler beim Hinzufügen des Meilensteins.",
        "Milestone_update_successfully": "Meilenstein erfolgreich aktualisiert.",
        "Error_in_updating_milestone": "Fehler beim Aktualisieren des Meilensteins.",
        "Milestone_status_update_successfully": "Meilensteinstatus erfolgreich aktualisiert.",
        "Error_in_updating_milestone_status": "Fehler beim Aktualisieren des Meilensteinstatus.",
        "Milestone_refund_amount_update_successfully": "Erstattung des Meilensteinbetrags erfolgreich aktualisiert.",
        "Error_in_updating_milestone_refund_amount": "Fehler beim Aktualisieren des Meilenstein-Erstattungsbetrags.",
        "The_project_not_found": "Das Projekt wurde nicht gefunden.",
        "The_project_is_archived": "Das Projekt ist archiviert.",
        "Start_date_of_project_should_be_smaller_than_current_date": "Das Startdatum des Projekts sollte kleiner als das heutige Datum sein.",
        "All_the_range_is_included_in_milestone": "Der gesamte Bereich ist im Meilenstein enthalten.",
        "Please_enter_start_date_of_project": "Bitte geben Sie das Startdatum des Projekts ein.",
        "Project_name_updated_successfully": "Projektname erfolgreich aktualisiert.",
        "Project restored successfully": "Projekt erfolgreich wiederhergestellt.",
        "Project closed successfully": "Projekt erfolgreich geschlossen.",
        "Project archived successfully": "Projekt erfolgreich archiviert.",
        "Project deleted successfully": "Projekt erfolgreich gelöscht.",
        "Enter_valid_project_source": "Geben Sie eine gültige Projektquelle ein.",
        "Please_select_sub_task": "Bitte wählen Sie eine Unteraufgabe.",
        "Status_not_updated": "Status wurde nicht aktualisiert.",
        "Start_date_updated_successfully": "Startdatum erfolgreich aktualisiert.",
        "Start_date_not_updated": "Startdatum wurde nicht aktualisiert.",
        "Task_converted_sucessfully": "Aufgabe erfolgreich konvertiert.",
        "Task_merged_sucessfully": "Aufgabe erfolgreich zusammengeführt.",
        "Can_not_create_template_name_Custom": "Vorlagenname 'Custom' kann nicht erstellt werden.",
        "Template_name_updated_successfully": "Vorlagenname erfolgreich aktualisiert.",
        "Template_has_been_created_Successfully": "Vorlage wurde erfolgreich erstellt.",
        "Template_deleted_successfull": "Vorlage erfolgreich gelöscht.",
        "Template_has_been_deleted_successfully": "Vorlage wurde erfolgreich gelöscht.",
        "Storage_exceeded_Upgrade_your_plan": "Speicher überschritten. Upgrade Ihren Plan.",
        "max_filesize_messages": "Die maximale Dateigröße beträgt FILE_SIZE MB.",
        "Password_reset_email_has_been_sent_successfully": "E-Mail zum Zurücksetzen des Passworts wurde erfolgreich gesendet.",
        "Invalid_username_or_password": "Ungültiger Benutzername oder Passwort.",
        "Email_Not_Verified": "E-Mail nicht verifiziert.",
        "Verification_mail_has_been_send_successfully": "Verifizierungs-E-Mail wurde erfolgreich gesendet.",
        "Invalid_url": "Ungültige URL.",
        "User_already_registered": "Benutzer bereits registriert.",
        "User_has_been_registered_successfully": "Benutzer wurde erfolgreich registriert.",
        "The_email_address_is_already_in_use": "Die E-Mail-Adresse wird bereits verwendet.",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "Benutzer wurde erfolgreich registriert. Bitte verifizieren Sie Ihre E-Mail, um fortzufahren.",
        "Password_reset_has_been_successfully": "Passwort zurückgesetzt.",
        "Your_email_has_been_verify_successfully": "Ihre E-Mail wurde erfolgreich verifiziert.",
        "Invitation_accepted_successfully": "Einladung erfolgreich akzeptiert.",
        "Only_product_owner_can_create_a_company": "Nur der Produktinhaber kann ein Unternehmen erstellen.",
        "Company_name_must_be_unique": "Der Firmenname muss eindeutig sein.",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Abonnement erfolgreich gekündigt. Bitte erlauben Sie 2 bis 3 Minuten, damit die Änderungen überall wirksam werden.",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Abonnement erfolgreich reaktiviert. Bitte erlauben Sie 2 bis 3 Minuten, damit die Änderungen überall wirksam werden.",
        "View_name_is_required": "Ansichtsname ist erforderlich.",
        "name_should_be_at_least_3_characters_long": "Der Name sollte mindestens 3 Zeichen lang sein.",
        "View_name_already_exists": "Ansichtsname existiert bereits.",
        "View_added_successfully": "Ansicht erfolgreich hinzugefügt.",
        "View_Deleted_Successfully": "Ansicht erfolgreich gelöscht.",
        "Link_copied_to_clipboard_successfully": "Link wurde erfolgreich in die Zwischenablage kopiert.",
        "Project_avatar_updated_successfully": "Projekt-Avatar erfolgreich aktualisiert.",
        "Message pinned successfully": "Nachricht erfolgreich angeheftet.",
        "Message unpinned successfully": "Nachricht erfolgreich entfernt.",
        "Message_copied": "Nachricht kopiert.",
        "Item_cannot_be_empty": "Artikel darf nicht leer sein.",
        "Maximum_MAX_CHAR_characters_are_allowed": "Maximal MAX_CHAR Zeichen sind erlaubt.",
        "Item_added_to_checklist": "Artikel zur Checkliste hinzugefügt.",
        "Maximum_10_files_can_be_uploaded_at_once": "Es können maximal 10 Dateien gleichzeitig hochgeladen werden.",
        "file_type_is_not_supported": "Dateityp wird nicht unterstützt!",
        "ERROR_in_file_upload": "Fehler beim Hochladen der Datei.",
        "file_size_is_larger_than_FILE_SIZE_mb": "Dateigröße ist größer als FILE_SIZE MB!",
        "Mark_as_favorite_successfully": "Erfolgreich als Favorit markiert.",
        "Start_and_Due_date_updated_successfully": "Start- und Fälligkeitsdatum erfolgreich aktualisiert.",
        "Start_and_Due_date_not_updated": "Start- und Fälligkeitsdatum wurden nicht aktualisiert.",
        "Attchments_deleted_successfully": "Anhänge wurden erfolgreich gelöscht.",
        "Designation_is_required": "Bezeichnung ist erforderlich.",
        "Designation_already_exists": "Bezeichnung existiert bereits.",
        "Designation_added_successfully": "Bezeichnung erfolgreich hinzugefügt.",
        "Designation_updated_successfully": "Bezeichnung erfolgreich aktualisiert.",
        "Role_is_required": "Rolle ist erforderlich.",
        "Role_already_exists": "Rolle existiert bereits.",
        "Role_added_successfully": "Rolle erfolgreich hinzugefügt.",
        "Role_updated_successfully": "Rolle erfolgreich aktualisiert.",
        "Please_provide_an_email_id": "Bitte geben Sie eine E-Mail-Adresse an.",
        "Please_provide_a_designation": "Bitte geben Sie eine Bezeichnung an.",
        "Please_provide_a_role": "Bitte geben Sie eine Rolle an.",
        "Designation_deleted_successfully": "Bezeichnung erfolgreich gelöscht.",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "Die Rolle wird bereits verwendet, daher kann sie nicht gelöscht werden.",
        "Role_deleted_successfully": "Rolle erfolgreich gelöscht.",
        "Language_not_updated": "Sprache wurde nicht aktualisiert!",
        "Profile_updated_successfully": "Profil erfolgreich aktualisiert.",
        "Notification_Settings_Update_successfully": "Benachrichtigungseinstellungen erfolgreich aktualisiert.",
        "Permission_updated_successfully": "Berechtigung erfolgreich aktualisiert.",
        "Per_User_Generate_Limit_value_is_not_valid": "Der Wert für das pro Benutzer Generierungs-Limit ist ungültig.",
        "Team_name_is_required": "Teamname ist erforderlich.",
        "Minimum_3_character_required": "Mindestens 3 Zeichen erforderlich.",
        "Team_name_already_exist": "Teamname existiert bereits.",
        "Template_has_been_added_successfully": "Vorlage wurde erfolgreich hinzugefügt.",
        "Billing_details_has_been_updated_successfully": "Rechnungsdetails wurden erfolgreich aktualisiert.",
        "Billing_details_not_updated": "Rechnungsdetails wurden nicht aktualisiert.",
        "Invalid_Card_Details_Please_check_and_try_again": "Ungültige Kartendaten. Bitte überprüfen und erneut versuchen.",
        "Expired_Card_Please_check_and_try_again": "Abgelaufene Karte. Bitte überprüfen und erneut versuchen.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "Ungültiger Kartenprüfcode (CVC). Bitte überprüfen und erneut versuchen.",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "Sie haben Ihr aktuelles Abonnement am Ende des Termins gekündigt. Bitte reaktivieren Sie Ihr Abonnement und versuchen Sie es erneut.",
        "Plan_not_purchased_Please_try_again": "Plan nicht gekauft. Bitte versuchen Sie es erneut.",
        "Please_fill_out_billing_details_first": "Bitte füllen Sie zuerst die Rechnungsdetails aus.",
        "Please_check_your_credential": "Bitte überprüfen Sie Ihre Anmeldedaten.",
        "File_type_not_supported": "Dateityp wird nicht unterstützt.",
        "Are_you_sure_to_delete_this_file": "Sind Sie sicher, dass Sie diese Datei löschen möchten?",
        "Select_Project_Type": "Wählen Sie den Projekttyp.",
        "Tracker_user_added_successfully": "Tracker-Benutzer erfolgreich hinzugefügt.",
        "Tracker_user_removed_successfully": "Tracker-Benutzer erfolgreich entfernt.",
        "queue_list_not_updated": "QueueList wurde nicht aktualisiert.",
        "upgrade_plan_folder_limit_reached": "Upgrade Ihren Plan. Sie haben das Limit für das Erstellen von Ordnern erreicht.",
        "View_updated_successfully": "Ansicht erfolgreich aktualisiert.",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "Die Bezeichnung wird bereits verwendet, daher kann sie nicht gelöscht werden.",
        "Sprint_already_exists": "Sprint existiert bereits.",
        "Folder_already_exists": "Ordner existiert bereits.",
        "Sprint updated successfully": "Sprint erfolgreich aktualisiert.",
        "Invalid_email": "Ihre E-Mail-Adresse ist ungültig. Bitte überprüfen Sie es und versuchen Sie es erneut",
        "Invalid_password": "Ihr Passwort ist ungültig. Bitte überprüfen Sie es und versuchen Sie es erneut",
        "Too_many_request": "Zu viele Anfragen. Bitte versuchen Sie es später noch einmal",
        "Password_reset_link": "E-Mail zur Passwortablaufbenachrichtigung erfolgreich gesendet! Bitte überprüfen Sie Ihren Posteingang, um mit dem Zurücksetzen Ihres Passworts fortzufahren.",
        "Project_milestone_status_added_successfully": "Projektmeilensteinstatus erfolgreich hinzugefügt.",
        "Please_select_start_end_date": "Bitte wählen Sie sowohl Start- als auch Enddatum aus",
        "Invitation_canceled": "Einladung storniert: Sie können diesen Link nicht mehr verwenden",
        "Ai_limit_reached": "Dein tägliches Limit wurde erreicht.",
        "You_have_reached_the_maximum_limit_of_guest_users": "Aktualisieren Sie Ihren Plan. Sie haben das maximale Limit für Gastbenutzer erreicht.",
        "Upgrade_for_import": "Aktualisieren Sie Ihren Plan, um die Importfunktion zu nutzen.",
        "Upgrade_for_export": "Aktualisieren Sie Ihren Plan, um die Exportfunktion zu nutzen.",
        "import_task_success": "Ihre Aufgaben wurden erfolgreich importiert.",
        "export_task_success": "Aufgaben erfolgreich exportiert.",
        "export_task_error": "Es gibt keine Aufgaben zum Exportieren.",
        "invalid_file_error": "Ungültiger Dateityp. Bitte laden Sie eine .csv-Datei hoch.",
        "free_company_limit_reached": "Sie haben die maximale Grenze für die Erstellung kostenloser Unternehmen erreicht.",
        "Import_users_successfully": "Benutzer erfolgreich importiert.",
        "date_range": "Bitte wählen Sie einen Datumsbereich aus, bevor Sie fortfahren.",
        "Task_total_estimate_update_succesfull": "Aufgabengesamtschätzung erfolgreich aktualisiert"
    },
    "SecurityAndPermission": {
        "project": "Projekt",
        "project_list": "Projektliste",
        "project_create": "Projekt erstellen",
        "project_name_edit": "Projektname bearbeiten",
        "project_sprint_create": "Projekt-Sprint erstellen",
        "project_folder_create": "Projektordner erstellen",
        "project_folder_name_edit": "Projektordnername bearbeiten",
        "project_sprint_name_edit": "Projekt-Sprint-Name bearbeiten",
        "project_details": "Projektdetails",
        "project_status_change": "Projektstatus ändern",
        "project_assignee": "Projektzuweisung",
        "project_category": "Projektkategorie",
        "project_source": "Projektquelle",
        "project_type": "Projekttyp",
        "project_currency": "Projektwährung",
        "project_amount": "Projektbetrag",
        "project_start_date": "Projektstartdatum",
        "project_end_date": "Projektenddatum",
        "project_due_date": "Projektfälligkeitsdatum",
        "project_close": "Projekt schließen",
        "project_description": "Projektbeschreibung",
        "project_checklist": "Projekt-Checkliste",
        "project_checklist_assign_remove": "Projekt-Checkliste zuweisen/entfernen",
        "project_attachments": "Projektanhänge",
        "project_milestone": "Projekt-Meilenstein",
        "task": "Aufgabe",
        "task_list": "Aufgabenliste",
        "task_create": "Aufgabe erstellen",
        "sub_task_create": "Unteraufgabe erstellen",
        "task_name_edit": "Aufgabenname bearbeiten",
        "task_status": "Aufgabenstatus",
        "task_assignee": "Aufgaben zuweisen",
        "task_priority": "Aufgabenpriorität",
        "task_due_date": "Aufgabefälligkeitsdatum",
        "task_estimated_hours": "Geschätzte Stunden für die Aufgabe",
        "task_description": "Aufgabenbeschreibung",
        "task_checklist": "Aufgaben-Checkliste",
        "task_checklist_assign_remove": "Aufgaben-Checkliste zuweisen/entfernen",
        "task_attachments": "Aufgabenanhänge",
        "show_tasks": "Aufgaben anzeigen",
        "task_custom_field": "Benutzerdefiniertes Feld",
        "settings": "Unternehmens-Einstellungen",
        "settings_edit_company": "Unternehmen bearbeiten",
        "settings_task_priority": "Aufgabenpriorität",
        "settings_file_extensions": "Dateierweiterungen",
        "settings_project_milestone_status": "Projekt-Meilenstein-Status",
        "settings_invite_member": "Mitglied einladen",
        "settings_member_list": "Mitgliederliste",
        "settings_create_team": "Team erstellen",
        "settings_team_list": "Teamliste",
        "settings_project_list": "Projektliste",
        "settings_security_permissions": "Sicherheit & Berechtigungen",
        "settings_role_management": "Rollenverwaltung",
        "settings_designation": "Bezeichnung",
        "milestone_weekly_range": "Meilenstein wöchentlicher Bereich",
        "settings_custom_field": "Benutzerdefiniertes Feld",
        "sheet_settings": "Tabelleneinstellungen",
        "user_timesheet": "Benutzer-Stundenzettel",
        "project_timesheet": "Projekt-Stundenzettel",
        "workload_timesheet": "Arbeitslast-Stundenzettel",
        "milestone_report": "Meilensteinbericht",
        "artificial_intelligence": "Künstliche Intelligenz",
        "per_user_generate_limit": "Generierungslimit pro Benutzer",
        "project_custom_field": "Benutzerdefiniertes Feld",
        "public_projects": "Öffentliche Projektliste",
        "tracker_timesheet": "Tracker-Stundenzettel",
        "view_list": "Liste anzeigen",
        "chat": "Συνομιλία",
        "project_delete": "Projekt löschen",
        "folder_archive": "Ordner archivieren",
        "folder_delete": "Ordner löschen",
        "folder_restore": "Ordner wiederherstellen",
        "sprint_type_change": "Änderung des Sprinttyps",
        "sprint_restore": "Sprint wiederherstellen",
        "sprint_delete": "Sprint löschen",
        "sprint_archive": "Sprint archivieren",
        "chat_channel": "Chatkanal erstellen",
        "chat_category": "Chatkategorie erstellen",
        "one_to_one_chat": "Eins-zu-eins-Chat",
        "task_tag": "Aufgaben-Tag",
        "task_start_date": "Aufgabenstartdatum",
        "task_activity_log": "Aktivitätsprotokoll",
        "task_convert_to_list": "Aufgabe in Liste umwandeln",
        "task_convert_to_subtask": "Aufgabe in Unteraufgabe umwandeln",
        "task_duplicate": "Aufgabe duplizieren",
        "task_merge": "Aufgaben zusammenführen",
        "task_move": "Aufgabe verschieben",
        "task_archive": "Aufgabe archivieren",
        "task_delete": "Aufgabe löschen",
        "task_comment": "Aufgabenkommentar",
        "task_details": "Aufgabendetails",
        "queue_list": "Warteliste",
        "advance_search": "Erweiterte Suche",
        "list_view_column": "Listenansichtsspalte",
        "import_tasks": "Aufgaben importieren",
        "export_tasks": "Aufgaben exportieren",
        "convert_to_task": "In Aufgabe umwandeln"
    },
    "general": {
        "Continue": "Fortfahren",
        "New_Status": "Neuer Status",
        "Old_Status": "Alter Status",
        "Old_Task_Type": "Alter Aufgabentyp",
        "New_Task_Type": "Neuer Aufgabentyp",
        "New_Task_Assignee": "Neuer Aufgaben-Zugewiesener",
        "Old_Task_Assignee": "Alter Aufgaben-Zugewiesener",
        "New_Task_Watchers": "Neue Aufgaben-Beobachter",
        "Old_Task_Watchers": "Alte Aufgaben-Beobachter",
        "Select_Status": "Status auswählen",
        "Select_Task_Type": "Aufgabentyp auswählen",
        "No_Assignee": "Kein Zugewiesener",
        "No_Watchers": "Keine Beobachter",
        "Different_Statuses": "Unterschiedliche Status",
        "Please_Select_Status": "Bitte Status auswählen",
        "Tomorrow": "Morgen",
        "Yesterday": "Gestern",
        "Project": "Projekt",
        "Team": "Team",
        "User": "Benutzer",
        "Copy_Assignees": "Zugewiesene kopieren",
        "Copy_Watchers": "Beobachter kopieren",
        "apply": "Anwenden",
        "current_month": "Aktueller Monat",
        "current_week": "Aktuelle Woche",
        "keyboard": "Tastatur",
        "mouse": "Maus",
        "Create": "Erstellen",
        "scroll_to_bottom": "Zum Ende scrollen",
        "unassigned": "Nicht zugewiesen",
        "entries": "Einträge",
        "showing": "Zeigt",
        "page_not_found": "Ups, Seite nicht gefunden",
        "page_not_found_description": "Es tut uns leid für die Unannehmlichkeiten. Es scheint, als würden Sie versuchen, auf eine Seite zuzugreifen, die gelöscht wurde oder nie existiert hat.",
        "note": "Notiz",
        "settings_change_no_effect": "Die Änderung der untenstehenden Einstellungen hat keine Auswirkungen auf aktuelle Feldwerte, wenn diese nicht leer sind",
        "advanced": "Erweitert",
        "general": "Allgemein",
        "limits": "Limits",
        "message_deleted": "Nachricht gelöscht",
        "company_individual": "Firmen-/Einzelname",
        "enter_company_individual": "Geben Sie den Firmen-/Personennamen ein"
    },
    "monthName": {
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mär",
        "apr": "Apr",
        "may": "Mai",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dez"
    },
    "timeLog": {
        "start_time_field_required": "Das Startzeit-Feld ist erforderlich",
        "end_time_field_required": "Das Endzeit-Feld ist erforderlich",
        "select_valid_time_duration": "Bitte wählen Sie eine gültige Zeitdauer"
    },
    "weekName": {
        "sun": "So",
        "mon": "Mo",
        "tue": "Di",
        "wed": "Mi",
        "thu": "Do",
        "fri": "Fr",
        "sat": "Sa",
        "fridays": "Freitage",
        "mondays": "Montage",
        "saturdays": "Samstage",
        "sundays": "Sonntage",
        "thursdays": "Donnerstage",
        "tuesdays": "Dienstage",
        "wednesdays": "Mittwoche"
    },
    "tooltipText": {
        "enable_app_manage_priority": "Indem Sie diese App aktivieren, können Sie die <b>Priorität</b> in <b>Aufgaben</b> für dieses <b>Projekt</b> verwalten.",
        "enable_app_manage_multiple_assignee": "Indem Sie diese App aktivieren, können Sie <b>mehrere Zugewiesene</b> in <b>Aufgaben</b> für dieses <b>Projekt</b> verwalten.",
        "enable_app_manage_time_estimates": "Indem Sie diese App aktivieren, können Sie <b>Zeitschätzungen</b> in <b>Aufgaben</b> für dieses <b>Projekt</b> verwalten.",
        "enable_app_manage_tags": "Indem Sie diese App aktivieren, können Sie <b>Tags</b> in <b>Aufgaben</b> für dieses <b>Projekt</b> verwalten.",
        "enable_app_use_milestones": "Indem Sie diese App aktivieren, können Sie <b>Meilensteine</b> für dieses <b>Projekt</b> verwenden.",
        "enable_app_use_ai_operations": "Indem Sie diese App aktivieren, können Sie <b>KI-Operationen</b> für dieses <b>Projekt</b> verwenden.",
        "enable_app_manage_time_log": "Indem Sie diese App aktivieren, können Sie <b>Zeiterfassung</b> in <b>Aufgaben</b> für dieses <b>Projekt</b> verwalten.",
        "enable_app_manage_custom_fields": "Indem Sie diese App aktivieren, können Sie <b>benutzerdefinierte Felder</b> für dieses <b>Projekt</b> verwalten."
    },
    "Company": {
        "fill_company_details": "Füllen Sie Ihre Firmendaten aus",
        "set_up_company": "Richten Sie Ihr Unternehmen ein",
        "creating_company": "Erstelle Unternehmen",
        "company_created": "Ihr Unternehmen wurde erstellt. Wir haben die ersten Schritte eingerichtet. Bitte warten Sie einen Moment.",
        "good_to_go": "Bereit zur Nutzung",
        "select_default_country": "Wählen Sie das Standardland",
        "freelimitreachedstart": "Sie haben bereits ein kostenloses Unternehmen erstellt. Um ein neues Unternehmen zu gründen, müssen Sie zuerst auf einen kostenpflichtigen Plan upgraden",
        "freelimitreachedend": "Nach dem Upgrade können Sie ein weiteres kostenloses Unternehmen hinzufügen."
    },
    "Subscription": {
        "subscription_cancelled": "Sie haben Ihr Abonnement am Ende des aktuellen Abrechnungszeitraums gekündigt.",
        "discard_changes": "Ein Benutzer in Ihrem Abonnement wird diese Änderungen verwerfen, und Ihr aktuelles Abonnement wird mit dem nächsten Abrechnungszyklus fortgesetzt.",
        "confirm_terminate_schedule": "Sind Sie sicher, dass Sie die geplante Kündigung des Abonnements beenden möchten?",
        "confirm_add_user": "Sind Sie sicher, dass Sie einen Benutzer zu Ihrem Abonnement hinzufügen möchten?",
        "confirm_remove_user": "Sind Sie sicher, dass Sie den Benutzer aus dem Abonnement entfernen möchten?",
        "next_invoice_amount": "Ihre nächste Rechnung wird betragen",
        "credits_applied": "Gutschriften angewendet",
        "current_billing_for_upgrade": "Aktuelle Abrechnung für das Upgrade",
        "plan_upgrade_success": "Herzlichen Glückwunsch! Ihr Plan-Upgrade wurde erfolgreich geplant, und die Verbesserungen werden nach Ende des aktuellen Zeitraums wirksam. Freuen Sie sich darauf, die verbesserten Funktionen und Vorteile in der nächsten Phase Ihres Abonnements zu erleben.",
        "subscription_upgrade_from": "Ihr Abonnement wird von",
        "total_payable_amount": "Gesamtbetrag zu zahlen",
        "update_subscription": "Abonnement aktualisieren",
        "updated_subscription_price": "Aktualisierter Abonnementpreis",
        "upgrade_subscription": "Abonnement upgraden",
        "confirm_subscription_change": "Sind Sie sicher, dass Sie Ihr Abonnement von",
        "monthly": "Monat",
        "yearly": "Jahr",
        "remove_scheduled_cancellation_confirmation": "Klicken auf 'Ja' entfernt die geplante Kündigung und Ihr Abrechnungszyklus wird fortgesetzt.",
        "scheduled_cancellation_notice": "Sie haben eine geplante Kündigung für Ihr aktuelles Abonnement am",
        "credit_entitlement_congratulations": "Herzlichen Glückwunsch! Sie haben Anspruch auf eine Gutschrift von",
        "credit_note_application": "für Ihr aktuelles Abonnement. Diese Gutschrift wird automatisch auf Ihr Abonnement angewendet und von Ihren zukünftigen Rechnungen abgezogen, was weiterhin Wert und Ersparnisse für Ihre Abonnementreise garantiert.",
        "invoice_period_coverage": "Die Rechnung deckt den Zeitraum ab"
    },
    "Card": {
        "pay_with": "Bezahlen mit",
        "add_new_card": "Neue Karte hinzufügen",
        "name_on_card": "Name auf der Karte",
        "card_number": "Kartennummer",
        "expiry": "Ablaufdatum",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "Sie müssen die erste Rechnungsadresse aktualisieren",
        "valid_csv_title": "Datei nicht hochgeladen",
        "valid_csv_text": "Bitte laden Sie eine gültige .csv-Datei hoch, um fortzufahren.",
        "ok": "OK",
        "cancel": "Abbrechen",
        "go_back_title": "Zurückgehen?",
        "go_back_text": "Möchten Sie wirklich zum vorherigen Schritt zurückkehren?",
        "close_modal_title": "Modales Fenster schließen?",
        "close_modal_text": "Möchten Sie das modale Fenster wirklich schließen? Alle bis zu diesem Schritt eingegebenen Informationen gehen verloren.",
        "no": "Nein",
        "yes": "Ja",
        "confirm": "Bestätigen",
        "improper_header_selection_title": "Ungültige Auswahl",
        "improper_header_selection_text": "Die ausgewählte Zeile enthält Werte, die keine Zeichenfolgen sind. Bitte wählen Sie eine andere Zeile.",
        "missing_fields_title": "Erforderliche Felder fehlen",
        "missing_fields_text": "Bevor Sie fortfahren, müssen Sie die erforderlichen Felder zuordnen und bestätigen.",
        "warning_title": "Warnung",
        "warning_text": "Wenn Sie fortfahren, werden leere Werte in 'Aufgabenpriorität' und 'Status' automatisch auf 'Mittel' bzw. 'Ausstehend' gesetzt.",
        "incomplete_mapping_title": "Unvollständige Zuordnung",
        "incomplete_mapping_text": "Bitte ordnen Sie alle eindeutigen Werte mindestens einem Wert in Hyphen OI Pro zu, um fortzufahren.",
        "invalid_tasks_error": "Keine gültigen Aufgaben gefunden. Bitte stellen Sie sicher, dass erforderliche Felder nicht leer sind."
    },
    "importTaskButton": {
        "import_title": "Aufgaben importieren",
        "import_button": "Aufgaben aus CSV importieren",
        "back_button": "Zurück",
        "next_button": "Weiter",
        "export_button": "Als CSV exportieren",
        "import_processing": "Ihre Aufgaben werden importiert."
    },
    "importCsvAndSetHeader": {
        "download": "Herunterladen",
        "demo_csv": "Demo-CSV",
        "down_demo_text": "Vergleichen Sie diese Datei mit Ihrer zu importierenden Datei, um sicherzustellen, dass sie korrekt ist.",
        "upload_button": "Laden Sie Ihre CSV-Datei hier hoch",
        "upload_instructions": "Sie können eine beliebige .csv-Datei mit beliebigen Spalten hochladen, wobei jede Zeile einen Eintrag darstellt. Im nächsten Schritt können Sie die Spalten Ihrer Tabelle den entsprechenden Datenpunkten zuordnen. Vor dem endgültigen Import können fehlerhafte Daten entfernt oder korrigiert werden.",
        "header_row_question": "Enthält die ausgewählte Zeile Spaltenüberschriften?",
        "select_another_button": "Andere Zeile auswählen",
        "confirm_row_btt": "Bestätigen"
    },
    "headerMapping": {
        "title": "Spaltenüberschriften zuordnen",
        "mapping_instructions": "Lassen Sie uns Ihre Überschriften den Hyphen OI Pro-Feldern zuordnen",
        "pending_count": "Verbleibende Felder:",
        "confirmed_count": "Bestätigte Felder:",
        "ignored_count": "Ignorierte Felder:",
        "custom_count": "Benutzerdefinierte Felder:",
        "confirmed_text": "Bestätigt",
        "ignored_text": "Ignoriert",
        "edit_button": "Bearbeiten",
        "no_match_title": "Keine Übereinstimmung",
        "no_match": "Keine Übereinstimmung gefunden",
        "no_match_description": "Dieses Feld entspricht keiner Hyphen OI Pro-Überschrift. Sie können es ignorieren oder als benutzerdefiniertes Feld hinzufügen.",
        "custom_field_button": "Als benutzerdefiniertes Feld hinzufügen",
        "ignore_field_button": "Dieses Feld ignorieren",
        "matched_to_field": "Zugeordnet zu Feld:",
        "duplication_warning": "Dieses Feld ist doppelt vorhanden und kann nicht bestätigt werden. Bitte wählen Sie ein anderes Feld.",
        "confirm_map_button": "Zuordnung bestätigen"
    },
    "reviewMaping": {
        "title": "Bitte überprüfen Sie die den Feldern zugeordneten Daten. (Sie können die Werte hier auch bearbeiten.)",
        "warning": "Ein oder mehrere erforderliche Felder fehlen oder enthalten ungültige Werte. Bitte überprüfen Sie sie, da diese Zeilen sonst nicht importiert werden."
    },
    "valueMapping": {
        "user_mapping_title": "Benutzerzuordnung",
        "user_mapping_instruction": "Ordnen Sie Benutzer den Hyphen OI Pro-Benutzern zu, um Aufgabenverantwortliche, Führungskräfte und Aktivitäten korrekt zuzuweisen. Wenn Sie keine Zuordnung vornehmen, werden diese Daten nicht importiert.",
        "user_dropdown_text": "Benutzer auswählen",
        "status_mapping_title": "Statuszuordnung",
        "status_mapping_instruction": "Um einen einheitlichen Workflow sicherzustellen, ordnen Sie Ihre Statuswerte bestehenden Werten in Hyphen OI Pro zu. Dies hilft, zukünftige Fehler zu vermeiden.",
        "status_dropdown_text": "Status auswählen",
        "priority_mapping_title": "Prioritätszuordnung",
        "priority_mapping_instruction": "Um einen einheitlichen Workflow sicherzustellen, ordnen Sie Ihre Prioritätswerte bestehenden Werten in Hyphen OI Pro zu. Dies hilft, zukünftige Fehler zu vermeiden.",
        "priority_dropdown_text": "Priorität auswählen",
        "custom_field_mapping_title": "Benutzerdefinierte Feldzuordnung",
        "custom_field_mapping_instruction": "Um die Kompatibilität sicherzustellen, ordnen Sie die Typen Ihrer benutzerdefinierten Felder bestehenden Typen in Hyphen OI Pro zu. Dies hilft, zukünftige Fehler zu vermeiden.",
        "custom_delimiters_quest": "ℹ️ Enthalten Ihre benutzerdefinierten Felder Trennzeichen?"
    },
    "importMappingKeywords": {
        "task_id_description": "Die ID der bestimmten Aufgabe.",
        "task_name_description": "Der Name der Aufgabe, normalerweise eine kurze Zusammenfassung.",
        "task_description_description": "Detaillierte Informationen zur Aufgabe.",
        "task_assignee_description": "Die E-Mail-Adresse der zugewiesenen Person.",
        "task_parentId_description": "Die ID der übergeordneten Aufgabe, mit der diese Aufgabe verknüpft ist.",
        "task_leaderId_description": "Die Benutzer-ID der Person, die diese Aufgabe leitet.",
        "task_priority_description": "Die der Aufgabe zugewiesene Prioritätsstufe.",
        "task_status_description": "Der aktuelle Status oder Fortschritt der Aufgabe.",
        "task_start_date_description": "Das Datum, an dem die Aufgabe beginnt.",
        "task_due_date_description": "Das Datum, bis zu dem die Aufgabe abgeschlossen sein soll."
    },
    "Affiliate": {
        "refer_earn": "Empfehlen & Verdienen",
        "unlimited": "Unbegrenzt",
        "invite_start_earning_cash_rewards": "Lade deine Freunde ein und beginne, Geldprämien zu verdienen.",
        "your_referral_code": "Dein Empfehlungscode",
        "invite_spend_message": "Für jede Ausgabe deines Freundes erhältst du {percentage}% des Betrags als Belohnung.",
        "inviteText": "Laden Sie Freunde ein, indem Sie diesen Link teilen",
        "copy": "Kopieren",
        "refferal_code_label": "Empfehlungscode",
        "refferal_code_placeholder": "Geben Sie den Empfehlungscode ein",
        "invalid_refferal_model_title": "Ihr Empfehlungscode ist ungültig",
        "invalid_refferal_model_confirm_text": "Ja, erstellen Sie es!",
        "invalid_refferal_model_text": "Sind Sie sicher, dass Sie ein Unternehmen gründen möchten?",
        "refferal_code_error": "Der Empfehlungscode ist ungültig"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "Zeigt ein Balkendiagramm Ihrer gesamten Aufgaben nach Beauftragtem an",
        "tasks_by_assignee_bar_chart_title": "Aufgaben nach Beauftragtem",
        "task_list_description": "Erstellen Sie eine Listenansicht mit Aufgaben aus einem beliebigen Standort",
        "tasks_list_title": "Aufgabenliste",
        "tasks_by_assignee_stack_bar_chart_description": "Zeigt eine gestapelte Darstellung Ihrer gesamten Aufgaben nach Beauftragtem an",
        "tasks_by_assignee_stack_bar_chart_title": "Aufgaben nach Beauftragtem",
        "workload_by_status_stack_bar_chart_description": "Zeigt eine Aufschlüsselung Ihrer Status über verschiedene Standorte hinweg",
        "workload_by_status_stack_bar_chart_title": "Arbeitslast nach Status",
        "tasks_by_assignee_pie_chart_description": "Zeigt ein Kreisdiagramm Ihrer gesamten Aufgaben nach Beauftragtem an",
        "tasks_by_assignee_pie_chart_title": "Aufgaben nach Beauftragtem",
        "workload_by_status_pie_chart_description": "Zeigt ein Kreisdiagramm zur Nutzung Ihrer Status über verschiedene Standorte hinweg",
        "workload_by_status_pie_chart_title": "Arbeitslast nach Status",
        "workload_by_status_bar_chart_description": "Zeigt ein Balkendiagramm zur Nutzung Ihrer Status über verschiedene Standorte hinweg",
        "workload_by_status_bar_chart_title": "Arbeitslast nach Status",
        "queue_list_title": "Wartelistenansicht",
        "queue_list_description": "Sehen Sie eine Liste Ihrer Aufgaben zusammen mit deren Status.",
        "card_name": "Kartenname",
        "location": "Projekt",
        "group_by": "Gruppieren nach",
        "show_assignees": "Beauftragte anzeigen",
        "include_subtasks": "Unteraufgaben einbeziehen",
        "display_labels_as_percent": "Beschriftungen als Prozentsatz anzeigen",
        "show_legend": "Legende anzeigen",
        "show_Data_Labels": "Datenbeschriftungen anzeigen",
        "select": "Auswählen",
        "add_card": "Karte hinzufügen",
        "back": "Zurück",
        "error_assignees": "Das Feld 'Beauftragte anzeigen' ist erforderlich",
        "error_location": "Das Feld 'Standort' ist erforderlich",
        "empty_layout_container": "Ihr Dashboard ist leer. Klicken Sie auf 'Karte hinzufügen', um zu beginnen.",
        "status": "Status",
        "edit_card": "Karte bearbeiten",
        "calendar_card_title": "Kalender",
        "calendar_card_description": "Dies ist die Kalenderansicht für Aufgaben",
        "measure": "Maß",
        "calculation": "Berechnung",
        "total_urgent_tasks": "Gesamtzahl der dringenden Aufgaben",
        "total_urgent_tasks_description": "Anzeige der Gesamtzahl dringender Aufgaben nach Standort",
        "time_tracker": "Zeiterfassung",
        "time_estimate": "Zeitschätzung",
        "range": "Bereich",
        "max": "Max",
        "min": "Min",
        "median": "Median",
        "average": "Durchschnitt",
        "sum": "Summe",
        "workload_estination_title": "Αναφορά χρόνου",
        "workload_estination_description": "Δείτε εργασίες με καταγεγραμμένο και εκτιμώμενο χρόνο.",
        "workload_only_estination_title": "Εκτιμώμενος χρόνος",
        "workload_only_estination_description": "Δείτε τον εκτιμώμενο χρόνο.",
        "time_only_estination_title": "Protokollierte Zeit",
        "time_only_estination_description": "Siehe protokollierte Zeit.",
        "today": "Heute",
        "yesterday": "Gestern",
        "this_week": "Diese Woche",
        "last_week": "Letzte Woche",
        "this_month": "Diesen Monat",
        "last_month": "Letzten Monat",
        "this_year": "Dieses Jahr",
        "last_30_days": "Letzten 30 Tage",
        "task": "Aufgabenzählung",
        "task_label": "Aufgabenetikett",
        "language": "German",
        "both": "Beide anzeigen",
        "manual_time": "Nur manuelle Zeit anzeigen",
        "track_time": "Nur erfasste Zeit anzeigen",
        "logtype": "Zeitprotokolle",
        "timerange": "Zeitraum",
        "priority": "Priorität",
        "due_date": "Fälligkeitsdatum",
        "none": "Keine",
        "total_time_track_description": "Gesamte aufgezeichnete Zeit anzeigen",
        "total_time_track_tasks": "Gesamte Zeitaufzeichnung",
        "total_tasks_count_description": "Gesamtanzahl der Aufgaben anzeigen",
        "total_tasks_count": "Gesamtanzahl der Aufgaben",
        "assignees": "Zugewiesene",
        "feature": "Funktion",
        "workload": "Arbeitsbelastung",
        "time_tracking": "Zeiterfassung",
        "task_card": "Aufgaben",
        "Today": "Heute",
        "Yesterday": "Gestern",
        "Tomorrow": "Morgen",
        "This_week": "Diese Woche",
        "Next_week": "Nächste Woche",
        "Next_seven_days": "Nächste sieben Tage",
        "Last_seven_days": "Letzte sieben Tage",
        "Last_month": "Letzter Monat",
        "This_month": "Dieser Monat",
        "Next_month": "Nächster Monat",
        "Date_range": "Datumsbereich",
        "me_mode": "ich",
        "data": "Daten",
        "display": "Anzeigen",
        "fields": "Felder"
    },
    "designationMapping": {
        "title": "Bezeichnungszuordnung",
        "description": "Bitte ordnen Sie die Bezeichnungen in Ihrer CSV den vorhandenen Bezeichnungen in Hyphen OI Pro zu."
    },
    "roleMapping": {
        "title": "Rollen-Zuordnung",
        "description": "Bitte ordnen Sie die Rollen in Ihrer CSV den vorhandenen Rollen in Hyphen OI Pro zu."
    },
    "importUserKeywords": {
        "user_email_description": "E-Mail-ID des Benutzers",
        "user_role_description": "Die dem Benutzer innerhalb der Organisation zugewiesene Rolle oder Berufsbezeichnung.",
        "user_designation_description": "Die offizielle Bezeichnung oder Berufsbezeichnung des Mitarbeiters im Unternehmen."
    },
    "userSelection": {
        "title": "Benutzerauswahl",
        "user_limit_error": "Maximale Benutzeranzahl erreicht. Bitte aktualisieren Sie Ihren Plan, um mehr Benutzer zu importieren.",
        "description": "Wählen Sie alle Benutzer aus, die Sie importieren möchten.",
        "duplicate_email_error": "Diese E-Mail-ID existiert bereits in Hyphen OI Pro. Sie können sie nicht importieren.",
        "invalid_email": "Diese E-Mail-ID ist ungültig. Bitte verwenden Sie eine gültige E-Mail-ID.",
        "invalid_fields": "Sie haben ein oder mehrere ungültige Felder. Bitte überprüfen Sie die markierten Felder.",
        "user_limit_100": "Sie können maximal 100 Benutzer auf einmal importieren."
    },
    "importUserButton": {
        "import_user_processing": "Ihre Benutzer werden importiert"
    },
    "timeForecastingReport": {
        "project_name": "Projektname",
        "project_status": "Projektstatus",
        "start_date": "Startdatum",
        "due_date": "Fälligkeitsdatum",
        "last_logged_date": "Letztes Protokolldatum",
        "budget": "Budget",
        "actual": "Ist-Wert",
        "forecast": "Prognose",
        "estimated_hours": "Geschätzte Stunden",
        "logged_hours": "Erfasste Stunden",
        "remaining_hours": "Verbleibende Stunden",
        "overdue_hours": "Überfällige Stunden",
        "estimated_time_to_complete": "Geschätzte Zeit bis zur Fertigstellung",
        "estimated_complition_date": "Voraussichtliches Fertigstellungsdatum",
        "show_legends": "Legenden anzeigen",
        "show_data_labels": "Datenbeschriftungen anzeigen",
        "report_type": "Berichtstyp"
    }
}